import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' })
};

@Injectable({
    providedIn: 'root'
})
export class RestApiService {
    httpClient: any;

    constructor(private http: HttpClient, private config: ConfigService) {
        this.httpClient = http;
    }
    
    apiRoot = this.config.apiRoot;
    slaRoot = this.config.slaRoot;
    externalRoot = this.config.externalRoot;
    reportRoot = this.config.reportRoot;
    indexRoot = this.config.indexRoot;
    userUploadApiRoot = this.config.userUploadRoot;
    geenrateReportRoot = this.config.generateReportRoot;


    addModule(data) {
        return this.http.post(this.apiRoot + '/addModule', data, httpOptions);
    }

    getModules() {
        return this.http.get(this.apiRoot + '/getModules');
    }

    addRole(data) {
        return this.http.post(this.apiRoot + '/addRole', data, httpOptions);
    }

    getRole() {
        return this.http.get(this.apiRoot + '/getRole');
    }

    getUrl() {
        return this.http.get(this.apiRoot + '/getUrl');
    }

    addUrl(data) {
        return this.http.post(this.apiRoot + '/createUrl', data, httpOptions);
    }

    getMappedModule(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getMappedModule?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getClient() {
        return this.http.get(this.apiRoot + '/getClient');
    }

    getModuleUrl(moduleId, clientId) {
        return this.http.get(this.apiRoot + '/getModuleUrl?clientId=' + clientId + '&moduleId=' + moduleId);
    }

    getModulesByClientId(clientId) {
        return this.http.get(this.apiRoot + '/getModulesByClientId?clientId=' + clientId);
    }

    mapModuleWithClient(data) {
        return this.http.post(this.apiRoot + '/mapModuleWithClient', data, httpOptions);
    }

    addClient(data) {
        return this.http.post(this.apiRoot + '/addClient', data, httpOptions);
    }

    getClientDetails(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getClientDetails?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getMappedURL(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getMappedURL?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    mapRoleWithClient(data) {
        return this.http.post(this.apiRoot + '/mapRoleWithClient', data, httpOptions);
    }

    getMappedRoleWithClient(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getMappedRoleWithClient?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    login(data) {
        return this.http.post(this.apiRoot + '/login', data, httpOptions);
    }

    insertUser(data) {
        return this.http.post(this.apiRoot + '/insertUser', data, httpOptions);
    }

    getUsers(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getUsers?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getUserClientWise(client_id) {
        return this.http.get(this.apiRoot + '/getUserClientWise?clientId=' + client_id);
    }

    getRoleClientWise(client_id) {
        return this.http.get(this.apiRoot + '/getRoleClientWise?client_id=' + client_id);
    }

    addUserRoleMapping(data) {
        return this.http.post(this.apiRoot + '/addUserRoleMapping', data, httpOptions);
    }

    getUserRolesMap(baseFlag, clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getUserRolesMap?clientId=' + clientId + '&baseFlag=' + baseFlag + '&nextOffset=' +
            nextOffset + '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    mapModuleRole(data) {
        return this.http.post(this.apiRoot + '/mapModuleRole', data, httpOptions);
    }

    getModuleRolesMapping(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getModuleRolesMapping?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getActions() {
        return this.http.get(this.apiRoot + '/getActions');
    }

    getUserdetails(user_id) {
        return this.http.get(this.apiRoot + '/getUserdetails?user_id=' + user_id);
    }

    getUsrActionMapping(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getUsrActionMapping?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }


    createUsrActionMapping(data) {
        return this.http.post(this.apiRoot + '/createUsrActionMapping', data, httpOptions);
    }

    setAdminUserAuth(data) {
        return this.http.post(this.apiRoot + '/setAdminUserAuth', data, httpOptions);
    }

    getUserAuthorization(data) {
        return this.http.get(this.apiRoot + '/getUserAuthorization?user_id=' + data.user_id + '&module=' + data.module);
    }

    getAdminUserAuth(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getAdminUserAuth?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deletePlatformModule(data) {
        return this.http.post(this.apiRoot + '/deletePlatformModule', data, httpOptions);
    }

    deleteUserRoleDB(data) {
        return this.http.post(this.apiRoot + '/deleteUserRoleDB', data, httpOptions);
    }

    deleteUrl(data) {
        return this.http.post(this.apiRoot + '/deleteUrl', data, httpOptions);
    }

    deleteUserFrmAdmin(data) {
        return this.http.post(this.apiRoot + '/deleteUserFrmAdmin', data, httpOptions);
    }

    deleteClient(data) {
        return this.http.post(this.apiRoot + '/deleteClient', data, httpOptions);
    }

    deleteMapModuleWithClient(data) {
        return this.http.post(this.apiRoot + '/deleteMapModuleWithClient', data, httpOptions);
    }

    deleteClientUserRole(data) {
        return this.http.post(this.apiRoot + '/deleteClientUserRole', data, httpOptions);
    }

    editModuleMst(data) {
        return this.http.post(this.apiRoot + '/editModuleMst', data, httpOptions);
    }

    editRoleMst(data) {
        return this.http.post(this.apiRoot + '/editRoleMst', data, httpOptions);
    }

    editUrlMst(data) {
        return this.http.post(this.apiRoot + '/editUrlMst', data, httpOptions);
    }

    editUserMst(data) {
        return this.http.post(this.apiRoot + '/editUserMst', data, httpOptions);
    }

    deleteUrlUserWise(data) {
        return this.http.post(this.apiRoot + '/deleteUrlUserWise', data, httpOptions);
    }

    deleteMapModuleRole(data) {
        return this.http.post(this.apiRoot + '/deleteMapModuleRole', data, httpOptions);
    }

    deleteClientUserRoleMapping(data) {
        return this.http.post(this.apiRoot + '/deleteClientUserRoleMapping', data, httpOptions);
    }

    deleteUsrActionMapping(data) {
        return this.http.post(this.apiRoot + '/deleteUsrActionMapping', data, httpOptions);
    }

    getUserByRole(data) {
        return this.http.get(this.apiRoot + '/getUserByRole?role_id=' + data.roleId + '&client_id=' + data.clientId);
    }

    mapModuleUserClient(data) {
        return this.http.post(this.apiRoot + '/mapModuleUserClient', data, httpOptions);
    }

    getMappedModuleUserClient(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getMappedModuleUserClient?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteModuleUserClient(data) {
        return this.http.post(this.apiRoot + '/deleteModuleUserClient', data, httpOptions);
    }

    getAdminModule() {
        return this.http.get(this.apiRoot + '/getAdminModule');
    }

    getUserNavbar(user_id) {
        return this.http.get(this.apiRoot + '/getUserNavbar?id=' + user_id);
    }

    getAdminUserAuthorization(user_id) {
        return this.http.get(this.apiRoot + '/getAdminUserAuthorization?refer_user_id=' + user_id);
    }

    deleteAdminUserAuth(data) {
        return this.http.post(this.apiRoot + '/deleteAdminUserAuth', data, httpOptions);
    }

    insertVendorMst(data) {
        return this.http.post(this.apiRoot + '/insertVendorMst', data, httpOptions);
    }

    getVendorMst(clientId) {
        return this.http.get(this.apiRoot + '/getVendorMst?clientId=' + clientId);
    }

    deleteVendorMst(data) {
        return this.http.post(this.apiRoot + '/deleteVendorMst', data, httpOptions);
    }

    updateVendorMst(data) {
        return this.http.post(this.apiRoot + '/updateVendorMst', data, httpOptions);
    }

    insertClientVendorUserMapping(data) {
        return this.http.post(this.apiRoot + '/insertClientVendorUserMapping', data, httpOptions);
    }

    getClientVendorUserMapping(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getClientVendorUserMapping?clientId=' + clientId +
            '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteClientVendorUserMapping(data) {
        return this.http.post(this.apiRoot + '/deleteClientVendorUserMapping', data, httpOptions);
    }

    insertSupportGrpLevel(data) {
        return this.http.post(this.apiRoot + '/insertSupportGrpLevel', data, httpOptions);
    }

    getSupportGrpLevel(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSupportGrpLevel?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    deleteSupportGrpLevel(data) {
        return this.http.post(this.apiRoot + '/deleteSupportGrpLevel', data, httpOptions);
    }

    getSupportGroupByClientId(clientId) {
        return this.http.get(this.apiRoot + '/getSupportGroupByClientId?clientId=' + clientId);
    }

    insertSupportGroupVendorMapping(data) {
        return this.http.post(this.apiRoot + '/insertSupportGroupVendorMapping', data, httpOptions);
    }

    getSupportGroupVendorMapping(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSupportGroupVendorMapping?clientId=' + clientId +
            '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteSupportGroupVendorMapping(data) {
        return this.http.post(this.apiRoot + '/deleteSupportGroupVendorMapping', data, httpOptions);
    }

    insertSupportGroupUserMapping(data) {
        return this.http.post(this.apiRoot + '/insertSupportGroupUserMapping', data, httpOptions);
    }

    getSupportGroupUserMapping(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSupportGroupUserMapping?clientId=' + clientId +
            '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }


    deleteSupportGroupUserMapping(data) {
        return this.http.post(this.apiRoot + '/deleteSupportGroupUserMapping', data, httpOptions);
    }

    mapRoleUserAction(data) {
        return this.http.post(this.apiRoot + '/mapRoleUserAction', data, httpOptions);
    }

    getUserWiseActions(clientId, roleId, user_id) {
        return this.http.get(this.apiRoot + '/getUserWiseActions?clientId=' + clientId + '&roleId=' + roleId + '&refer_user_id=' + user_id);
    }

    getRoleWiseActions(clientId, roleId) {
        return this.http.get(this.apiRoot + '/getRoleWiseActions?clientId=' + clientId + '&roleId=' + roleId);
    }

    getRoleUserActionMap(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getRoleUserActionMap?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }


    insertTicketProperty(data) {
        return this.http.post(this.apiRoot + '/insertTicketProperty', data, httpOptions);
    }

    getTicketProperty(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getTicketProperty?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteRoleUserAction(data) {
        return this.http.post(this.apiRoot + '/deleteRoleUserAction', data, httpOptions);
    }

    getMenuDtlsClientWise(clientId, moduleId) {
        return this.http.get(this.apiRoot + '/getMenuDtlsClientWise?clientId=' + clientId + '&moduleId=' + moduleId);
    }

    getMenuDtlsAllClientWise(clientId, moduleId) {
        return this.http.get(this.apiRoot + '/getMenuDtlsAllClientWise?clientId=' + clientId + '&moduleId=' + moduleId);
    }

    insertMenuDtlsClientWise(data) {
        return this.http.post(this.apiRoot + '/insertMenuDtlsClientWise', data, httpOptions);
    }

    getMenuCompleteDtlsClientWise(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getMenuCompleteDtlsClientWise?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getDynamicMenuDtls(clientId, user_id) {
        return this.http.get(this.apiRoot + '/getDynamicMenuDtls?id=' + clientId + '&user_id=' + user_id);
    }

    updateMenuDtlsWithUrlClientWise(data) {
        return this.http.post(this.apiRoot + '/updateMenuDtlsWithUrlClientWise', data, httpOptions);
    }

    insertAttributesHeaderMstClientWise(data) {
        return this.http.post(this.apiRoot + '/insertAttributesHeaderMstClientWise', data, httpOptions);
    }

    getAttributesHeaderMstClientWise(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getAttributesHeaderMstClientWise?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    updateAttributesHeaderMstClientWise(data) {
        return this.http.post(this.apiRoot + '/updateAttributesHeaderMstClientWise', data, httpOptions);
    }

    deleteAttributesHeaderMstClientWise(data) {
        return this.http.post(this.apiRoot + '/deleteAttributesHeaderMstClientWise', data, httpOptions);
    }

    insertTicketAttributesClientWise(data) {
        return this.http.post(this.apiRoot + '/insertTicketAttributesClientWise', data, httpOptions);
    }

    getTicketAttrClientAttributesWise(clientId, seq, ticketId) {
        return this.http.get(this.apiRoot + '/getTicketAttrClientAttributesWise' +
            '?clientId=' + clientId + '&seq=' + seq + '&ticket_type=' + ticketId);
    }

    getTicketAttrClientAttributesWise_chr(clientId, seq, ticketId, areaSelected1) {
        return this.http.get(this.apiRoot + '/getTicketAttrClientAttributesWise_chr' +
            '?clientId=' + clientId + '&seq=' + seq + '&ticket_type=' + ticketId + '&areaSelected1=' + areaSelected1);
    }


    deleteTicketAttributesClientWise(data) {
        return this.http.post(this.apiRoot + '/deleteTicketAttributesClientWise', data, httpOptions);
    }

    insertBusinessImpact(data) {
        return this.http.post(this.apiRoot + '/insertBusinessImpact', data, httpOptions);
    }

    insertBusinessPriority(data) {
        return this.http.post(this.apiRoot + '/insertBusinessPriority', data, httpOptions);
    }

    insertBusinessUrgency(data) {
        return this.http.post(this.apiRoot + '/insertBusinessUrgency', data, httpOptions);
    }

    deleteBusinessImpact(data) {
        return this.http.post(this.apiRoot + '/deleteBusinessImpact', data, httpOptions);
    }

    deleteBusinessPriority(data) {
        return this.http.post(this.apiRoot + '/deleteBusinessPriority', data, httpOptions);
    }

    deleteBusinessUrgency(data) {
        return this.http.post(this.apiRoot + '/deleteBusinessUrgency', data, httpOptions);
    }

    updateBusinessImpact(data) {
        return this.http.post(this.apiRoot + '/updateBusinessImpact', data, httpOptions);
    }

    updateBusinessPriority(data) {
        return this.http.post(this.apiRoot + '/updateBusinessPriority', data, httpOptions);
    }

    updateBusinessUrgency(data) {
        return this.http.post(this.apiRoot + '/updateBusinessUrgency', data, httpOptions);
    }

    getBusinessImpact(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getBusinessImpact?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }


    getWFCClientBackward(id) {
        return this.http.get(this.apiRoot + '/getWFCClientBackward?id=' + id);
    }

    getBusinessPriority(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getBusinessPriority?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    getBusinessPriorityTicketTypeWise(clientId, ticket_type) {
        return this.http.get(this.apiRoot + '/getBusinessPriorityTicketTypeWise?clientId=' + clientId + '&ticket_type=' + ticket_type);
    }

    getBusinessUrgency(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getBusinessUrgency?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }


    insertMappingWithTicketAttrSuppGrp(data) {
        return this.http.post(this.apiRoot + '/insertMappingWithTicketAttrSuppGrp', data, httpOptions);
    }

    getMappingWithTicketAttrSuppGrp(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getMappingWithTicketAttrSuppGrp?clientId='
            + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteMappingWithTicketAttrSuppGrp(data) {
        return this.http.post(this.apiRoot + '/deleteMappingWithTicketAttrSuppGrp', data, httpOptions);
    }

    getTicketType(clientId) {
        return this.http.get(this.apiRoot + '/getTicketType?clientId=' + clientId);
    }

    getTicketTypeForTicketCreation(clientId) {
        return this.http.get(this.apiRoot + '/getTicketTypeForTicketCreation?clientId=' + clientId);
    }

    getTicketTypeForTicketCreation_LNT(clientId, groupId) {
        return this.http.get(this.apiRoot + '/getTicketTypeForTicketCreation_LNT?clientId=' + clientId + '&suppGroupId=' + groupId);
    }

    getSupportGroupByVendor(clientId, vendorId) {
        return this.http.get(this.apiRoot + '/getSupportGroupByVendor?clientId=' + clientId + '&vendorId=' + vendorId);
    }

    getSLADetails(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSLADetails?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    updateSupportGrpLevel(data) {
        return this.http.post(this.apiRoot + '/updateSupportGrpLevel', data, httpOptions);

    }

    deleteSLADetails(data) {
        return this.http.post(this.apiRoot + '/deleteSLADetails', data, httpOptions);
    }

    insertSLADetails(data) {
        return this.http.post(this.apiRoot + '/insertSLADetails', data, httpOptions);
    }

    updateSLADetails(data) {
        return this.http.post(this.apiRoot + '/updateSLADetails', data, httpOptions);
    }

    getBusinessMatrix(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getBusinessMatrix?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }


    insertBusinessMatrix(data) {
        return this.http.post(this.apiRoot + '/insertBusinessMatrix', data, httpOptions);
    }

    deleteBusinessMatrix(data) {
        return this.http.post(this.apiRoot + '/deleteBusinessMatrix', data, httpOptions);
    }


    getMetadataTable() {
        return this.http.get(this.apiRoot + '/getMetadataTable');
    }

    mapTableAction(data) {
        return this.http.post(this.apiRoot + '/mapTableAction', data, httpOptions);
    }

    getTableWiseActions(clientId, roleId, tableId, urlId) {
        return this.http.get(this.apiRoot + '/getTableWiseActions?clientId=' + clientId +
            '&roleId=' + roleId + '&tableId=' + tableId + '&urlId=' + urlId);
    }

    getTableActionMap(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getTableActionMap?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteTableAction(data) {
        return this.http.post(this.apiRoot + '/deleteTableAction', data, httpOptions);
    }

    getFieldByTable(tableId) {
        return this.http.get(this.apiRoot + '/getFieldByTable?tableId=' + tableId);
    }

    mapTableFieldAction(data) {
        return this.http.post(this.apiRoot + '/mapTableFieldAction', data, httpOptions);
    }

    getTableFieldWiseActions(clientId, roleId, tableId, fieldId, urlId) {
        return this.http.get(this.apiRoot + '/getTableFieldWiseActions?' +
            'clientId=' + clientId + '&roleId=' + roleId + '&tableId=' + tableId + '&fieldId=' + fieldId + '&urlId=' + urlId);
    }

    getTableFieldActionMap(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getTableFieldActionMap?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }


    deleteTableFieldAction(data) {
        return this.http.post(this.apiRoot + '/deleteTableFieldAction', data, httpOptions);
    }

    mapTableUrl(data) {
        return this.http.post(this.apiRoot + '/mapTableUrl', data, httpOptions);
    }

    getTableUrlMap(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getTableUrlMap?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteTableUrl(data) {
        return this.http.post(this.apiRoot + '/deleteTableUrl', data, httpOptions);
    }

    getUrlByTable(tableId) {
        return this.http.get(this.apiRoot + '/getUrlByTable?tableId=' + tableId);
    }

    mapTableUserAction(data) {
        return this.http.post(this.apiRoot + '/mapTableUserAction', data, httpOptions);
    }

    getTableUserWiseActions(clientId, roleId, tableId, urlId, user_id) {
        return this.http.get(this.apiRoot + '/getTableUserWiseActions?clientId=' + clientId + '&roleId=' + roleId + '&tableId=' + tableId +
            '&urlId=' + urlId + '&refer_user_id=' + user_id);
    }

    getTableUserActionMap(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getTableUserActionMap?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteTableUserAction(data) {
        return this.http.post(this.apiRoot + '/deleteTableUserAction', data, httpOptions);
    }

    mapTableFieldUserAction(data) {
        return this.http.post(this.apiRoot + '/mapTableFieldUserAction', data, httpOptions);
    }

    getTableFieldUserWiseActions(clientId, roleId, tableId, fieldId, urlId, user_id) {
        return this.http.get(this.apiRoot + '/getTableFieldUserWiseActions?' +
            'clientId=' + clientId + '&roleId=' + roleId + '&tableId=' + tableId +
            '&fieldId=' + fieldId + '&urlId=' + urlId + '&refer_user_id=' + user_id);
    }

    getTableFieldUserActionMap(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getTableFieldUserActionMap?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteTableFieldUserAction(data) {
        return this.http.post(this.apiRoot + '/deleteTableFieldUserAction', data, httpOptions);
    }

    insertWorkFlow(data) {
        return this.http.post(this.apiRoot + '/insertWorkFlow', data, httpOptions);
    }

    getWorkFlow() {
        return this.http.get(this.apiRoot + '/getWorkFlow');
    }

    updateWorkFlow(data) {
        return this.http.post(this.apiRoot + '/updateWorkFlow', data, httpOptions);
    }

    deleteWorkFlow(data) {
        return this.http.post(this.apiRoot + '/deleteWorkFlow', data, httpOptions);
    }

    insertWorkFlowComponent(data) {
        return this.http.post(this.apiRoot + '/insertWorkFlowComponent', data, httpOptions);
    }

    getWorkFlowComponent(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getWorkFlowComponent?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteWorkFlowComponent(data) {
        return this.http.post(this.apiRoot + '/deleteWorkFlowComponent', data, httpOptions);
    }

    insertWorkFlowComponentDetails(data) {
        return this.http.post(this.apiRoot + '/insertWorkFlowComponentDetails', data, httpOptions);
    }

    getWorkFlowComponentDetails(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getWorkFlowComponentDetails?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteWorkFlowComponentDetails(data) {
        return this.http.post(this.apiRoot + '/deleteWorkFlowComponentDetails', data, httpOptions);
    }

    deleteWFCClient(data) {
        return this.http.post(this.apiRoot + '/deleteWFCClient', data, httpOptions);
    }

    getWFCClient(clientId, nextOffset, pageSize, paginationType, indicator) {
        return this.http.get(this.apiRoot + '/getWFCClient?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType + '&indicator=' + indicator);
    }

    getWFCClientByClientId(clientId, ticketType, workflowId, categoryId, indicatorId) {
        return this.http.get(this.apiRoot + '/getWFCClientByClientId?' +
            'clientId=' + clientId + '&workflowId=' + workflowId + '&categoryId=' + categoryId +
            '&indicatorId=' + indicatorId + '&ticketType=' + ticketType);
    }

    insertWFCClient(data) {
        return this.http.post(this.apiRoot + '/insertWFCClient', data, httpOptions);
    }

    searchZone(zone) {
        return this.http.get(this.apiRoot + '/searchZone?zone=' + zone);
    }

    getComponentsByworkflowId(workflowId) {
        return this.http.get(this.apiRoot + '/getComponentsByworkflowId?workflowId=' + workflowId);
    }

    getTicketCreateLoadingDtls(user_id, ttype, clientId) {
        return this.http.get(this.apiRoot + '/getTicketCreateLoadingDtls?user_id=' + user_id + '' +
            '&ticket_type=' + ttype + '&clientId=' + clientId);
    }

    getCreateTicketData(user_id, ttype, clientId) {
        return this.http.get(this.apiRoot + '/getCreateTicketData?user_id=' + user_id + '' +
            '&ticket_type=' + ttype + '&clientId=' + clientId);
    }

    getTicketCreateLoadingDtls_lnt(user_id, ttype, clientId, cat1, cat2) {
        return this.http.get(this.apiRoot + '/getTicketCreateLoadingDtls_lnt?user_id=' + user_id + '&ticket_type=' + ttype +
            '&clientId=' + clientId + '&cat1=' + cat1 + '&cat2=' + cat2);
    }

    getDocuTicketDetails(user_id, ttype) {
        return this.http.get(this.apiRoot + '/getDocuTicketDetails?user_id=' + user_id + '&ticket_type=' + ttype);
    }

    getBusinessPriorityImpactUrgencyBasis(clientId, impactId, urgencyId) {
        return this.http.get(this.apiRoot + '/getBusinessPriorityImpactUrgencyBasis' +
            '?clientId=' + clientId + '&busi_impact_id=' + impactId + '&busi_urgency_id=' + urgencyId);
    }

    getAttributesParentWise(clientId, parentId) {
        return this.http.get(this.apiRoot + '/getAttributesParentWise?clientId=' + clientId + '&parentId=' + parentId);
    }

    getLastLevelCategory(clientId) {
        return this.http.get(this.apiRoot + '/getLastLevelCategory?clientId=' + clientId);
    }

    getSupportGroupByCategory(clientId, categoryId) {
        return this.http.get(this.apiRoot + '/getSupportGroupByCategory?' +
            'clientId=' + clientId + '&categoryId=' + categoryId);
    }

    getSupportGroupByCategory1(clientId, categoryId, groupId, ticketTypeId, ticketId = null) {
        return this.http.get(this.apiRoot + '/getSupportGroupByCategory1?' +
            'clientId=' + clientId + '&categoryId=' + categoryId + '&groupId=' + groupId + '&ticketTypeId=' + ticketTypeId +
            '&ticketId=' + ticketId);
    }

    getUserByGroup(clientId, groupId) {
        return this.http.get(this.apiRoot + '/getUserByGroup?clientId=' + clientId + '&groupId=' + groupId);
    }

    getUserByGroup1(clientId, groupId, referId, user_id) {
        return this.http.get(this.apiRoot + '/getUserByGroup1?clientId=' + clientId + '&groupId=' + groupId + '' +
            '&user_id=' + user_id + '&referId=' + referId);
    }

    getStatus(clientId) {
        return this.http.get(this.apiRoot + '/getStatus?clientId=' + clientId);
    }

    updateTicketCategory(data) {
        return this.http.post(this.apiRoot + '/updateTicketCategory', data, httpOptions);
    }

    getMappedTicketType(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getMappedTicketType?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getMappedStatus(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getMappedStatus?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    createTicket(data) {
        return this.http.post(this.apiRoot + '/createTicket', data, httpOptions);
    }


    createBulkAssignTicket(data){
        return this.http.post(this.apiRoot + '/createBulkAssignTicket', data, httpOptions)
    }

    createReAssignmentTicketJob(data){
        return this.http.post(this.apiRoot + '/createReAssignmentTicketJob', data, httpOptions)
    }
    
    getTicketByMe(data) {
        return this.http.get(this.apiRoot + '/getTicketByMe?' +
            'user_id=' + data.user_id + '&ticketTypeId=' + data.ticketTypeId +
            '&start=' + data.start + '&limit=' + data.limit + '&supportgrp_id=' + data.supportgrp_id + '&clientId=' + data.clientId);
    }

    getNextAssigneeDtls(clientId, id, createdby) {
        return this.http.get(this.apiRoot + '/getNextAssigneeDtls?clientId=' + clientId + '&id=' + id + '&createdby=' + createdby);
    }

    updateForwardedTicket(data) {
        return this.http.post(this.apiRoot + '/updateForwardedTicket', data, httpOptions);
    }

    getTicketCategoryDetails(clientId, id, typeId, disableField, suppGrpId = null, working_category = null) {
        return this.http.get(this.apiRoot + '/getTicketCategoryDetails?clientId=' + clientId + '&ticketId='
            + id + '&typeId=' + typeId + '&disableField=' + disableField + '&suppGrpId=' + suppGrpId + '&cat_id=' + working_category);
    }

    getTicketCategoryDetails_SSC(clientId, id, typeId, disableField, suppGrpId = null, working_category = null) {
        return this.http.get(this.apiRoot + '/getTicketCategoryDetails_SSC?clientId=' + clientId + '&ticketId='
            + id + '&typeId=' + typeId + '&disableField=' + disableField + '&suppGrpId=' + suppGrpId + '&cat_id=' + working_category);
    }

    getTicketCategoryDetailsWithGroup(clientId, id, typeId, disableField, groupId) {
        return this.http.get(this.apiRoot + '/getTicketCategoryDetailsWithGroup?clientId=' + clientId + '&ticketId='
            + id + '&typeId=' + typeId + '&disableField=' + disableField + '&groupId=' + groupId);
    }

    getOpenTicketInMyGroup(data) {
        return this.http.get(this.apiRoot + '/getOpenTicketInMyGroup?user_id=' + data.user_id + '&ticketTypeId=' + data.ticketTypeId + '' +
            '&start=' + data.start + '&limit=' + data.limit + '&supportgrp_id=' + data.supportgrp_id + '&clientId=' + data.clientId);
    }

    getMyCloseTicket(data) {
        return this.http.get(this.apiRoot + '/getMyCloseTicket?' +
            'user_id=' + data.user_id + '&ticketTypeId=' + data.ticketTypeId +
            '&start=' + data.start + '&limit=' + data.limit + '&supportgrp_id=' + data.supportgrp_id + '&clientId=' + data.clientId);
    }

    getCloseTicketInMyGroup(data) {
        return this.http.get(this.apiRoot + '/getCloseTicketInMyGroup?user_id=' + data.user_id + '&ticketTypeId=' + data.ticketTypeId +
            '&start=' + data.start + '&limit=' + data.limit + '&supportgrp_id=' + data.supportgrp_id + '&clientId=' + data.clientId);
    }

    getMyForwardedTickets(data) {
        return this.http.get(this.apiRoot + '/getMyForwardedTickets?' +
            'user_id=' + data.user_id + '&ticketTypeId=' + data.ticketTypeId + '&start=' + data.start +
            '&limit=' + data.limit + '&supportgrp_id=' + data.supportgrp_id + '&clientId=' + data.clientId);
    }

    getMyForwardedTicketsInGroup(data) {
        return this.http.get(this.apiRoot + '/getMyForwardedTicketsInGroup?user_id=' + data.user_id + '&ticketTypeId=' + data.ticketTypeId
            + '&start=' + data.start + '&limit=' + data.limit + '&supportgrp_id=' + data.supportgrp_id + '&clientId=' + data.clientId);
    }

    getAssignedByMe(data) {
        return this.http.get(this.apiRoot + '/getAssignedByMe?' +
            'user_id=' + data.user_id + '&ticketTypeId=' + data.ticketTypeId + '&start=' + data.start +
            '&limit=' + data.limit + '&supportgrp_id=' + data.supportgrp_id + '&clientId=' + data.clientId);
    }

    getOpenTicketInMyCategoryGroup(data) {
        return this.http.get(this.apiRoot + '/getOpenTicketInMyCategoryGroup?' +
            'user_id=' + data.user_id + '&ticketTypeId=' + data.ticketTypeId + '&start=' + data.start +
            '&limit=' + data.limit + '&supportgrp_id=' + data.supportgrp_id + '&clientId=' + data.clientId);
    }

    getCloseTicketInMyCategoryGroup(data) {
        return this.http.get(this.apiRoot + '/getCloseTicketInMyCategoryGroup?' +
            'user_id=' + data.user_id + '&ticketTypeId=' + data.ticketTypeId + '&start=' + data.start +
            '&limit=' + data.limit + '&supportgrp_id=' + data.supportgrp_id + '&clientId=' + data.clientId);
    }

    getStatusForClient(clientId) {
        return this.http.get(this.apiRoot + '/getStatusForClient?clientId=' + clientId);
    }

    getUserClientWiseNotAssignInGrp(clientId) {
        return this.http.get(this.apiRoot + '/getUserClientWiseNotAssignInGrp?clientId=' + clientId);
    }

    submitFeedbackTicketWise(data) {
        return this.http.post(this.apiRoot + '/submitFeedbackTicketWise', data, httpOptions);
    }

    getCommentsByTicketId(ticketId) {
        return this.http.get(this.apiRoot + '/getCommentsByTicketId?ticketId=' + ticketId);
    }

    updateTicketStatus(data) {
        return this.http.post(this.apiRoot + '/updateTicketStatus', data, httpOptions);
    }

    updateTicketStatusWithClose(data) {
        return this.http.post(this.apiRoot + '/updateTicketStatusWithClose', data, httpOptions);
    }

    getLogsTicketWise(ticketId) {
        return this.http.get(this.apiRoot + '/getLogsTicketWise?ticketId=' + ticketId);
    }

    updateTicket(data) {
        return this.http.post(this.apiRoot + '/updateTicket', data, httpOptions);
    }

    submitSolutionsTicketWise(data) {
        return this.http.post(this.apiRoot + '/submitSolutionsTicketWise', data, httpOptions);
    }

    getSolutionsTicketWise(ticketId) {
        return this.http.get(this.apiRoot + '/getSolutionsTicketWise?ticketId=' + ticketId);
    }

    getAttachmentTicketWise(ticketId) {
        return this.http.get(this.apiRoot + '/getAttachmentTicketWise?ticketId=' + ticketId);
    }

    getSupportGrpWithoutVendor(clientId) {
        return this.http.get(this.apiRoot + '/getSupportGrpWithoutVendor?clientId=' + clientId);
    }

    getUserWithOrWithoutVendorMapping(clientId, reqFlg, groupId, psOrName) {
        return this.http.get(this.apiRoot + '/getUserWithOrWithoutVendorMapping?clientId=' +
            clientId + '&reqFlg=' + reqFlg + '&groupId=' + groupId + '&psOrName=' + psOrName);
    }

    getAdditionalFunc() {
        return this.http.get(this.apiRoot + '/getAdditionalFunc');
    }

    getAdditionalFuncTicketTypeWise(clientId, fieldId) {
        return this.http.get(this.apiRoot + '/getAdditionalFuncTicketTypeWise?clientId='
            + clientId + '&functionalityId=' + fieldId);
    }

    insertAdditionalFuncTicketTypeUserWise(data) {
        return this.http.post(this.apiRoot + '/insertAdditionalFuncTicketTypeUserWise', data, httpOptions);
    }

    getAdditionalFuncTicketTypeUserWise(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getAdditionalFuncTicketTypeUserWise?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    getFirstLevelCategory(clientId) {
        return this.http.get(this.apiRoot + '/getFirstLevelCategory?clientId=' + clientId);
    }

    getFirstLevelCategoryByTicket(clientId, ticketId) {
        return this.http.get(this.apiRoot + '/getFirstLevelCategoryByTicket?clientId=' + clientId + '&ticket_type=' + ticketId);
    }

    getCategoryByTicketTypeNDynamicLevel(clientId, ticketId) {
        return this.http.get(this.apiRoot + '/getCategoryByTicketTypeNDynamicLevel?clientId=' + clientId + '&ticket_type=' + ticketId);
    }

    getDynamicMenuTicketTypeWise(clientId, ticketTypeId, user_id, functionalityId, groupId, workspaceType = null) {
        return this.http.get(this.apiRoot + '/getDynamicMenuTicketTypeWise?clientId=' + clientId + '&ticketTypeId=' + ticketTypeId +
            '&functionalityId=' + functionalityId + '&user_id=' + user_id + '&supportgrp=' + groupId + '&workspaceType=' + workspaceType);
    }

    insertWFCClientBackWard(data) {
        return this.http.post(this.apiRoot + '/insertWFCClientBackWard', data, httpOptions);
    }

    getDynamicTabTicketTypeWise(clientId, ticketTypeId, user_id) {
        return this.http.get(this.apiRoot + '/getDynamicTabTicketTypeWise?clientId='
            + clientId + '&ticketTypeId=' + ticketTypeId + '&user_id=' + user_id);
    }

    getDynamicTabActionTicketTypeWise(clientId, ticketTypeId, user_id, groupId) {
        return this.http.get(this.apiRoot + '/getDynamicTabActionTicketTypeWise?clientId='
            + clientId + '&ticketTypeId=' + ticketTypeId + '&user_id=' + user_id + '&supportgrp_id=' + groupId);
    }

    getWorkflowType() {
        return this.http.get(this.apiRoot + '/getWorkflowType');
    }

    deleteDynamicTabActionTicketTypeWise(data) {
        return this.http.post(this.apiRoot + '/deleteDynamicTabActionTicketTypeWise', data, httpOptions);
    }

    insertTicketExtandMstTbl(data) {
        return this.http.post(this.apiRoot + '/insertTicketExtandMstTbl', data, httpOptions);
    }

    getTicketExtandMstTbl(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getTicketExtandMstTbl?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }


    deleteTicketExtandMstTbl(data) {
        return this.http.post(this.apiRoot + '/deleteTicketExtandMstTbl', data, httpOptions);
    }

    getBackwardWorkFlowType(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getBackwardWorkFlowType?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getUrlByClient(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getUrlByClient?client_id=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getUnmappedLeafMenu(clientId, moduleId) {
        return this.http.get(this.apiRoot + '/getUnmappedLeafMenu?clientId=' + clientId + '&moduleId=' + moduleId);
    }

    getRemainingUrlDtls(clientId, moduleId) {
        return this.http.get(this.apiRoot + '/getRemainingUrlDtls?clientId=' + clientId + '&moduleId=' + moduleId);
    }

    getRoleUserActionMapping(data) {
        return this.http.post(this.apiRoot + '/getRoleUserActionMapping', data, httpOptions);
    }

    mapNewUrlToModule(data) {
        return this.http.post(this.apiRoot + '/mapNewUrlToModule', data, httpOptions);
    }

    getUrlSequence(data) {
        return this.http.post(this.apiRoot + '/getUrlSequence', data, httpOptions);
    }

    updateMenuDtls(data) {
        return this.http.post(this.apiRoot + '/updateMenuDtls', data, httpOptions);
    }

    getSLA(ticketId, user_id) {
        return this.http.get(this.apiRoot + '/getSlaCompletionPercentage?ticketId=' + ticketId + '&user_id=' + user_id);
    }

    insertSLAClientWiseDetails(data) {
        return this.http.post(this.apiRoot + '/insertSLAClientWiseDetails', data, httpOptions);
    }

    updateSLAClientWiseDetails(data) {
        return this.http.post(this.apiRoot + '/updateSLAClientWiseDetails', data, httpOptions);
    }

    deleteSLAClientWiseDetails(data) {
        return this.http.post(this.apiRoot + '/deleteSLAClientWiseDetails', data, httpOptions);
    }

    getSLAClientWiseDetails(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSLAClientWiseDetails?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    insertHoliday(data) {
        return this.http.post(this.apiRoot + '/insertHoliday', data, httpOptions);
    }

    updateHoliday(data) {
        return this.http.post(this.apiRoot + '/updateHoliday', data, httpOptions);
    }

    getHoliday(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getHoliday?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    getAllClients() {
        return this.http.get(this.apiRoot + '/getAllClients');
    }

    getTicketFieldsCatWise(data) {
        return this.http.get(this.apiRoot + '/getTicketFieldsCatWise?clientId=' + data.clientId + '' +
            '&catId=' + data.catId + '&ticketTypeId=' + data.ticketTypeId);
    }

    getAddionalFieldWithValue(ticketId) {
        return this.http.get(this.apiRoot + '/getAddionalFieldWithValue?ticketId=' + ticketId);
    }

    getSlaReport(startDate, endDate, clientId, ticket_type, category, ticket_status) {
        return this.http.get(this.apiRoot + '/getSalReport?fromDt=' + startDate + '&toDt=' + endDate + '&clientid=' + clientId +
            '&ticket_type=' + ticket_type + '&category=' + category + '&ticket_status=' + ticket_status);
    }

    deleteHolidayDateVal(data) {
        return this.http.post(this.apiRoot + '/deleteHolidayDateVal', data, httpOptions);
    }

    insertTicketEscalationDtlsSupportGrpWise(data) {
        return this.http.post(this.apiRoot + '/insertTicketEscalationDtlsSupportGrpWise', data, httpOptions);
    }

    getTicketEscalationDtlsSupportGrpWise(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getTicketEscalationDtlsSupportGrpWise?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    insertTicketIdConfigure(data) {
        return this.http.post(this.apiRoot + '/insertTicketIdConfigure', data, httpOptions);
    }

    updateHolidayDateVal(data) {
        return this.http.post(this.apiRoot + '/updateHolidayDateVal', data, httpOptions);
    }

    getTicketIdConfigure(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getTicketIdConfigure?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    getClientWiseSupportGroupList(clientId) {
        return this.http.get(this.apiRoot + '/getClientWiseSupportGroupList?clientId=' + clientId);
    }

    getMappedModuleUserClientCWise(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getMappedModuleUserClientCWise?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    getModuleRolesMappingClientWise(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getModuleRolesMappingClientWise?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    insertTicketPriorityConfiguration(data) {
        return this.http.post(this.apiRoot + '/insertTicketPriorityConfiguration', data, httpOptions);
    }

    getTicketPriorityConfiguration(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getTicketPriorityConfiguration?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    getPriorityMapping(clientId, ticket_type) {
        return this.http.get(this.apiRoot + '/getPriorityMapping?clientId=' + clientId + '&ticket_type=' + ticket_type);
    }

    insertSlaRecalculationMstForm(data) {
        return this.http.post(this.apiRoot + '/insertSlaRecalculationMstForm', data, httpOptions);
    }

    getSlaRecalculationMstForm(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSlaRecalculationMstForm?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    getAttributesParentWiseWithPriority(clientId, parentId, pType, tType) {
        return this.http.get(this.apiRoot + '/getAttributesParentWiseWithPriority?' +
            'clientId=' + clientId + '&parentId=' + parentId + '&pType=' + pType + '&tType=' + tType);
    }

    getUsrActionMappingWithClientId(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getUsrActionMappingWithClientId?clientId=' + clientId +
            '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getRoleUserActionMapWithClientId(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getRoleUserActionMapWithClientId?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    getAssetManagementMaster(clientId) {
        return this.http.get(this.apiRoot + '/getAssetManagementMaster?client_id=' + clientId);
    }

    addAssetManagementMaster(data) {
        return this.http.post(this.apiRoot + '/addAssetManagementMaster', data, httpOptions);
    }

    deleteAssetManagementMaster(data) {
        return this.http.post(this.apiRoot + '/deleteAssetManagementMaster', data, httpOptions);
    }

    editAssetManagementMaster(data) {
        return this.http.post(this.apiRoot + '/editAssetManagementMaster', data, httpOptions);
    }

    getAssetManagementColumn(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getAssetManagementColumn?client_id=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    addAssetManagementColumn(data) {
        return this.http.post(this.apiRoot + '/addAssetManagementColumn', data, httpOptions);
    }

    deleteAssetManagementColumn(data) {
        return this.http.post(this.apiRoot + '/deleteAssetManagementColumn', data, httpOptions);
    }

    editAssetManagementColumn(data) {
        return this.http.post(this.apiRoot + '/editAssetManagementColumn', data, httpOptions);
    }

    // ==================================================
    getAssetManagementValue(clientId) {
        return this.http.get(this.apiRoot + '/getAssetManagementValue?clientId=' + clientId);
    }

    addAssetManagementValue(data) {
        return this.http.post(this.apiRoot + '/addAssetManagementValue', data, httpOptions);
    }

    deleteAssetManagementValue(data) {
        return this.http.post(this.apiRoot + '/deleteAssetManagementValue', data, httpOptions);
    }

    editAssetManagementValue(data) {
        return this.http.post(this.apiRoot + '/editAssetManagementValue', data, httpOptions);
    }

    getAttributesHeaderMstClientTicketTypeWise(clientId, ticketId) {
        return this.http.get(this.apiRoot + '/getAttributesHeaderMstClientTicketTypeWise?clientId=' + clientId + '' +
            '&ticket_type=' + ticketId);
    }

    mapRoleAction(data) {
        return this.http.post(this.apiRoot + '/mapRoleAction', data, httpOptions);
    }

    getAssetDescription(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getAssetDescription?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    addAssetDescription(data) {
        return this.http.post(this.apiRoot + '/addAssetDescription', data, httpOptions);
    }

    deleteAssetDescription(data) {
        return this.http.post(this.apiRoot + '/deleteAssetDescription', data, httpOptions);
    }

    editAssetDescription(data) {
        return this.http.post(this.apiRoot + '/editAssetDescription', data, httpOptions);
    }

    getAssetColumnByMaster(clientId, masterId) {
        return this.http.get(this.apiRoot + '/getAssetColumnByMaster?clientId=' + clientId + '&masterId=' + masterId);
    }

    getAssetDetailsByMaster(clientId, masterId) {
        return this.http.get(this.apiRoot + '/getAssetDetailsByMaster?clientId=' + clientId + '&masterId=' + masterId);
    }

    getAssetManagementData(clientId, masterId) {
        return this.http.get(this.apiRoot + '/getAssetManagementData?clientId=' + clientId + '&masterId=' + masterId);
    }

    getTicketWiseAssetData(ticketId, masterId) {
        return this.http.get(this.apiRoot + '/getTicketWiseAssetData?ticketId=' + ticketId + '&masterId=' + masterId);
    }

    getAssetMasterByTicket(ticketId) {
        return this.http.get(this.apiRoot + '/getAssetMasterByTicket?ticketId=' + ticketId);
    }

    deleteTicketAssetData(data) {
        return this.http.post(this.apiRoot + '/deleteTicketAssetData', data, httpOptions);
    }

    insertAssetIds(data) {
        return this.http.post(this.apiRoot + '/insertAssetIds', data, httpOptions);
    }

    deleteBackwardWorkFlow(data) {
        return this.http.post(this.apiRoot + '/deleteBackwardWorkFlow', data, httpOptions);
    }

    searchAssetManagementData(clientId, masterId, columnId, assetValue, page, pageSize) {
        return this.http.get(this.apiRoot + '/searchAssetManagementData?clientId=' + clientId + '&masterId=' + masterId + '&columnId=' +
            columnId + '&assetValue=' + assetValue + '&page_no=' + page + '&page_size=' + pageSize);
    }

    maintainAssetManagementData(clientId, assetValue) {
        return this.http.get(this.apiRoot + '/maintainAssetManagementData?client_id=' + clientId + '&assetValue=' + assetValue);
    }

    editAssetValue(data) {
        return this.http.post(this.apiRoot + '/editAssetValue', data, httpOptions);
    }

    escalationByCreatorAfterResolve(data) {
        return this.http.post(this.apiRoot + '/escalationByCreatorAfterResolve', data, httpOptions);
    }

    getAttributesHeaderMstClientWiseWithTicket(clientId, ticket_type) {
        return this.http.get(this.apiRoot + '/getAttributesHeaderMstClientWiseWithTicket?clientId=' + clientId +
            '&ticket_type=' + ticket_type);
    }

    getAllIncidentTicketDetails(clientId) {
        return this.http.get(this.apiRoot + '/getAllIncidentTicketDetails?clientId=' + clientId);
    }

    approveProblemTicket(data) {
        return this.http.post(this.apiRoot + '/approveProblemTicket', data, httpOptions);
    }

    getIncidentTicketDetails(clientId, ticket_type, user_id) {
        return this.http.get(this.apiRoot + '/getIncidentTicketDetails?clientId=' + clientId +
            '&ticket_type=' + ticket_type + '&user_id=' + user_id);
    }

    changeTicketStatus(data) {
        return this.http.post(this.apiRoot + '/changeTicketStatus', data, httpOptions);
    }

    getMappedIncidentTicketDetails(clientId, ticket_type, ticketId) {
        return this.http.get(this.apiRoot + '/getMappedIncidentTicketDetails?clientId=' + clientId +
            '&ticket_type=' + ticket_type + '&id=' + ticketId);
    }

    getTicketById(data) {
        return this.http.get(this.apiRoot + '/getTicketById?clientId=' + data.clientId + '&ticketId=' + data.ticketId);
    }

    getSubTicketType(clientId, ticketId) {
        return this.http.get(this.apiRoot + '/getSubTicketType?clientId=' + clientId + '&ticket_type=' + ticketId);
    }

    deleteNewIncidentInProblem(data) {
        return this.http.post(this.apiRoot + '/deleteNewIncidentInProblem', data, httpOptions);
    }

    forwardProblemTicketAfterChangesToApprover(data) {
        return this.http.post(this.apiRoot + '/forwardProblemTicketAfterChangesToApprover', data, httpOptions);
    }

    addNewIncidentInProblem(data) {
        return this.http.post(this.apiRoot + '/addNewIncidentInProblem', data, httpOptions);
    }

    getDocuActions() {
        return this.http.get(this.apiRoot + '/getDocuActions');
    }

    getUsersByMultiGroup(clientId, groups) {
        return this.http.get(this.apiRoot + '/getUsersByMultiGroup?clientId=' + clientId + '&groups=' + groups);
    }

    uploadDocument(data) {
        return this.http.post(this.apiRoot + '/uploadDocument', data, httpOptions);
    }

    getDataByCategory(clientId, categoryId, user_id) {
        return this.http.get(this.apiRoot + '/getDataByCategory?clientId=' + clientId + '&categoryId='
            + categoryId + '&user_id=' + user_id);
    }

    getDataByText(clientId, text, user_id) {
        return this.http.get(this.apiRoot + '/getDataByText?clientId=' + clientId + '&text=' + text + '&user_id=' + user_id);
    }

    getDataByEmail(clientId, email, user_id) {
        return this.http.get(this.apiRoot + '/getDataByEmail?clientId=' + clientId + '&email=' + email + '&user_id=' + user_id);
    }

    getDocumentDetails(clientId, docuId, typeId) {
        return this.http.get(this.apiRoot + '/getDocumentDetails?clientId=' + clientId + '&docuId=' + docuId + '&typeId=' + typeId);
    }

    getActionsByDocuId(clientId, docuId) {
        return this.http.get(this.apiRoot + '/getActionsByDocuId?clientId=' + clientId + '&docuId=' + docuId);
    }

    updateDocument(data) {
        return this.http.post(this.apiRoot + '/updateDocument', data, httpOptions);
    }

    getAttachmentByDocuId(docuId) {
        return this.http.get(this.apiRoot + '/getAttachmentByDocuId?docuId=' + docuId);
    }

    addDocuComment(data) {
        return this.http.post(this.apiRoot + '/addDocuComment', data, httpOptions);
    }

    getCommentsByDocuId(docuId) {
        return this.http.get(this.apiRoot + '/getComments?docuId=' + docuId);
    }

    autoSearch(clientId, searchKeyword) {
        return this.http.get(this.apiRoot + '/autoSearchKeyword?clientId=' + clientId +
            '&searchKeyword=' + searchKeyword);
    }

    searchDocuId(clientId, searchKeyword) {
        return this.http.get(this.apiRoot + '/searchDocuId?id=' + searchKeyword + '&clientId=' + clientId);
    }

    getGroupsByDocument(clientId) {
        return this.http.get(this.apiRoot + '/getGroupsByDocument?clientId=' + clientId);
    }

    getActionsByDocument(docuId, clientId) {
        return this.http.get(this.apiRoot + '/getActionsByDocument?clientId=' + clientId + '&docuId=' + docuId);
    }

    addUserActionDocumentWise(data) {
        return this.http.post(this.apiRoot + '/addUserActionDocumentWise', data, httpOptions);
    }

    deleteActionDocumentWise(data) {
        return this.http.post(this.apiRoot + '/deleteActionDocumentWise', data, httpOptions);
    }

    deleteDocument(data) {
        return this.http.post(this.apiRoot + '/deleteDocument', data, httpOptions);
    }

    getSomeModules(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSomeModules?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getSomeRoleClientWise(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSomeRoleClientWise?client_id=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getUserByClient(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getUserByClient?client_id=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getSomeTicketType(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSomeTicketType?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    getSomeStatus(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSomeStatus?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getSomeAssetManagementMaster(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSomeAssetManagementMaster?client_id=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    getSomeVendorMst(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSomeVendorMst?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getRSDBData(clientId, ticket_type, categoryId, user_id, creatorId, type) {
        return this.http.get(this.apiRoot + '/getRSDBData?clientId=' + clientId + '&ticket_type=' + ticket_type +
            '&categoryId=' + categoryId + '&ref_user_id=' + user_id + '&creatorId=' + creatorId + '&rsdb_type=' + type);
    }

    getLoginClientList() {
        return this.http.get(this.apiRoot + '/getLoginClientList');
    }

    loginlt(data) {
        console.log("REST API loginlt", data);
        return this.http.post(this.apiRoot + '/loginlt', data, httpOptions);
    }

    generateToken(clientId, loginName) {
        console.log('generateToken sending...');
        return this.http.get(this.apiRoot + '/generateToken?clientId=' + clientId + '&login_name=' + loginName);
    }

    tokenValidation(data) {
        return this.http.post(this.apiRoot + '/tokenValidation', data, httpOptions);
    }

    getAttributesHeaderMstTicketTypewise(data) {
        return this.http.get(this.apiRoot + '/getAttributesHeaderMstTicketTypewise?client_id=' + data.client_id +
            '&ticket_type=' + data.ticket_type);
    }

    insertWFCGeneratedFor(data) {
        return this.http.post(this.apiRoot + '/insertWFCGeneratedFor', data, httpOptions);
    }

    getTicketDetailForRSDB(ticketId, typeId) {
        return this.http.get(this.apiRoot + '/getTicketDetailForRSDB?id=' + ticketId + '&ticketTypeId=' + typeId);
    }

    getWFCGeneratedDetails(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getWFCGeneratedDetails?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getWorkFlowWithPagination(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getWorkFlowWithPagination?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getUserDetailsByLoginId(clientId, loginId) {
        return this.http.get(this.apiRoot + '/getUserDetailsByLoginId?clientId=' + clientId + '&loginId=' + loginId);
    }

    submitUserReplyFotTicketIfo(data) {
        return this.http.post(this.apiRoot + '/submitUserReplyFotTicketIfo', data, httpOptions);
    }


    getPsDetails(psNo) {
        console.log("getPsDetails==", psNo);
        
        if (this.config.type === 'LOCAL') {
            return this.http.get(this.externalRoot + '/getEmployeeDetails?psNO=' + psNo);
        } else {
            console.log("this.apiRoot==", this.apiRoot);
            return this.http.get(this.apiRoot + '/getEmployeeDetails?psNO=' + psNo);
        }
        // return this.http.get('https://sscinternalapps.larsentoubro.com/employeedata/employeecontact.asmx/getPersonalDetails?psno=' + psNo);
    }


    // getPsDetails(psNo) {
    //     if (this.config.type === 'LOCAL') {
    //         return this.http.get(this.externalRoot + '/getEmployeeDetails?psNO=' + psNo);
    //     } else {
    //           return this.http.get(this.externalRoot + '/getEmployeeDetails?psNO=' + psNo);
    //     //    return this.http.get(this.apiRoot + '/getEmployeeDetails?psNO=' + psNo);
    //     }
    //     // return this.http.get('https://sscinternalapps.larsentoubro.com/employeedata/employeecontact.asmx/getPersonalDetails?psno=' + psNo);
    // }

    getIpClient() {
        return this.http.get('http://api.ipify.org/?format=json&callback=JSON_CALLBACK');
    }

    insertUserSession(data) {
        return this.http.post(this.apiRoot + '/insertUserSession', data, httpOptions);
    }

    searchTicket(user_id, type, statusType, value, ticketTypeId, supportgrp_id) {
        return this.http.get(this.apiRoot + '/searchTicket?user_id=' + user_id +
            '&type=' + type + '&statusType=' + statusType + '&value=' + value + '&ticketTypeId=' + ticketTypeId +
            '&supportgrp_id=' + supportgrp_id);
    }

    getRequesterInfo(user_id, ticketId) {
        return this.http.get(this.apiRoot + '/getRequesterInfo?user_id=' + user_id + '&ticketId=' + ticketId);
    }

    getStatusClientSSC(user_id, clientId, ticketId, ticketTypeId) {
        return this.http.get(this.apiRoot + '/getStatusClientSSC?user_id=' + user_id + '&clientId=' + clientId + '&ticketId=' + ticketId +
            '&typeId=' + ticketTypeId);
    }

    getPriorityForLTSSC(user_id, clientId, ticket_type, priority) {
        return this.http.get(this.apiRoot + '/getPriorityForLTSSC?user_id=' + user_id + '&clientId=' +
            clientId + '&ticket_type=' + ticket_type + '&priority=' + priority);
    }

    getLastCommentByTicketId(user_id, ticketId) {
        return this.http.get(this.apiRoot + '/getLastCommentByTicketId?user_id=' + user_id + '&ticketId=' + ticketId);
    }

    getDashBoardDtls(clientId, groupId, ticketType) {
        return this.http.get(this.apiRoot + '/getDashBoardDtls?clientId=' + clientId + '&supportgrp_id=' +
            groupId + '&ticketTypeId=' + ticketType);
    }

    getDashBoardDtls_new(clientId, groupId, ticketType, type, categoryId, userId) {
        return this.http.get(this.apiRoot + '/getDashBoardDtls_new?clientId=' + clientId + '&supportgrp_id=' +
            groupId + '&ticketTypeId=' + ticketType + '&type=' + type + '&catFilterVal=' + categoryId + '&userFilterVal=' + userId);
    }


    checkIsLead(clientId, groupId, user_id) {
        return this.http.get(this.apiRoot + '/checkIsLead?clientId=' + clientId + '&supportgrp_id=' +
            groupId + '&user_id=' + user_id);
    }

    // -----------------------------------------------------
    getStatusByTicketTypeLt(ticket_type, clientId) {
        return this.http.get(this.apiRoot + '/getStatusByTicketTypeLt?ticketTypeSeqNo=' + ticket_type + '&clientId=' + clientId);
    }

    getSupportGroupByTicketTypeLt(ticket_type_id, clientId) {
        return this.http.get(this.apiRoot + '/getSupportGroupByTicketTypeLt?ticket_type_id=' + ticket_type_id + '&clientId=' + clientId);
    }

    insertMailTemplateLt(data) {
        return this.http.post(this.apiRoot + '/insertMailTemplateLt', data, httpOptions);
    }

    getMailTemplateLt(nextOffset, pageSize, paginationType, clientId) {
        return this.http.get(this.apiRoot + '/getMailTemplateLt?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType + '&clientId=' + clientId);
    }

    deleteMailTemplateLt(data) {
        return this.http.post(this.apiRoot + '/deleteMailTemplateLt', data, httpOptions);
    }

    addFollowup(data) {
        return this.http.post(this.apiRoot + '/addFollowupLt', data, httpOptions);
    }

    getFollowupLt(nextOffset, pageSize, paginationType, clientId) {
        return this.http.get(this.apiRoot + '/getFollowupLt?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType + '&clientId=' + clientId);
    }

    deleteFollowUpLt(data) {
        return this.http.post(this.apiRoot + '/deleteFollowUpLt', data, httpOptions);
    }

    updateFollowupLt(data) {
        return this.http.post(this.apiRoot + '/updateFollowupLt', data, httpOptions);
    }

    getDynamicMenuTicketDtls(data) {
        return this.http.get(this.apiRoot + '/getDynamicMenuTicketDtls?' +
            'user_id=' + data.user_id + '&ticketTypeId=' + data.ticketTypeId +
            '&start=' + data.start + '&limit=' + data.limit + '&supportgrp_id=' + data.supportgrp_id +
            '&clientId=' + data.clientId + '&menuId=' + data.menuId + '&userFilterVal=' + data.userFilterVal +
            '&catFilterVal=' + data.catFilterVal + '&nextOffset=' + data.nextOffset + '&page_size='
            + data.page_size + '&specialFilterVal=' + data.specialFilterVal +
            '&paginationType=' + data.paginationType);
    }

    getFollowupUserLt(data) {
        return this.http.get(this.apiRoot + '/getFollowupUserLt?' +
            'user_id=' + data.user_id + '&ticketTypeId=' + data.ticketTypeId +
            '&busi_priority_id=' + data.busi_priority_id + '&category_id=' + data.category_id + '&tStatus=' + data.tStatus +
            '&clientId=' + data.clientId + '&ticketId=' + data.ticketId);
    }

    getDashBoardDtlsForLeader(clientId, groupId, ticketType, categoryId) {
        return this.http.get(this.apiRoot + '/getDashBoardDtlsForLeader?clientId=' + clientId + '&supportgrp_id=' +
            groupId + '&ticketTypeId=' + ticketType + '&catFilterVal=' + categoryId);
    }

    getDashBoardDtlsForTeamLead(clientId, groupId, ticketType, categoryId, userId) {
        return this.http.get(this.apiRoot + '/getDashBoardDtlsForTeamLead?clientId=' + clientId + '&supportgrp_id=' +
            groupId + '&ticketTypeId=' + ticketType + '&catFilterVal=' + categoryId + '&userFilterVal=' + userId);
    }

    getAllLevelOneUser(clientId) {
        return this.http.get(this.apiRoot + '/getAllLevelOneUser?clientId=' + clientId);
    }

    insertEscalation(data) {
        return this.http.post(this.apiRoot + '/insertEscalation', data, httpOptions);
    }

    getEscalateDetails(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getEscalateDetails?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType + '&clientId=' + clientId);
    }

    deleteEscalation(data) {
        return this.http.post(this.apiRoot + '/deleteEscalation', data, httpOptions);
    }

    insertEscalationSupportGroup(data) {
        return this.http.post(this.apiRoot + '/insertEscalationSupportGroup', data, httpOptions);
    }

    deleteEscalationSupportGroup(data) {
        return this.http.post(this.apiRoot + '/deleteEscalationSupportGroup', data, httpOptions);
    }

    getEscalationSupportGroup(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getEscalationSupportGroup?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType + '&clientId=' + clientId);
    }

    updateEscalationSupportGroup(data) {
        return this.http.post(this.apiRoot + '/updateEscalationSupportGroup', data, httpOptions);
    }

    getFaqCategory(clientId) {
        return this.http.get(this.apiRoot + '/getFaqCategory?clientId=' + clientId);
    }

    getFaqDetails(clientId, masterCategoryId) {
        return this.http.get(this.apiRoot + '/getFaqDetails?clientId=' + clientId + '&masterCategoryId=' +
            masterCategoryId);
    }

    getFaqSearchData(clientId, value, user_id) {
        return this.http.get(this.apiRoot + '/getFaqSearchData?clientId=' + clientId + '&user_id=' + user_id + '&searchKeyword=' +
            value);
    }

    checkOfflineNotificationData(ticketId, groupId, userId, clientId) {
        return this.http.get(this.apiRoot + '/checkOfflineNotificationData?ticketId=' + ticketId + '&groupId=' +
            groupId + '&user_id=' + userId + '&clientId=' + clientId);
    }

    checkOfflineDashNotification(clientId, groupId, userId, ticketTypeId, functionalityId) {
        return this.http.get(this.apiRoot + '/checkOfflineDashNotification?clientId=' + clientId + '&groupId=' +
            groupId + '&user_id=' + userId + '&ticketTypeId=' + ticketTypeId + '&functionalityId=' +
            functionalityId);
    }

    updateOfflineNotificationData(data) {
        return this.http.post(this.apiRoot + '/updateOfflineNotificationData', data, httpOptions);
    }

    getAllFaqCategory(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getAllFaqCategory?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType + '&clientId=' + clientId);
    }

    insertFaqCategory(data) {
        return this.http.post(this.apiRoot + '/insertFaqCategory', data, httpOptions);
    }

    deleteFaqCategory(data) {
        return this.http.post(this.apiRoot + '/deleteFaqCategory', data, httpOptions);
    }

    updateFaqCategory(data) {
        return this.http.post(this.apiRoot + '/updateFaqCategory', data, httpOptions);
    }

    getAllFaq(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getAllFaq?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType + '&clientId=' + clientId);
    }

    insertFaq(data) {
        return this.http.post(this.apiRoot + '/insertFaq', data, httpOptions);
    }

    deleteFaq(data) {
        return this.http.post(this.apiRoot + '/deleteFaq', data, httpOptions);
    }

    updateFaq(data) {
        return this.http.post(this.apiRoot + '/updateFaq', data, httpOptions);
    }

    AdvancesearchTicket(data) {
        return this.http.post(this.apiRoot + '/AdvancesearchTicket', data, httpOptions);
    }

    getCategoryListSupportGroupWise(groupId, clientId, ticketTypeId) {
        return this.http.get(this.apiRoot + '/getCategoryListSupportGroupWise?groupId=' + groupId + '&clientId=' +
            clientId + '&ticketTypeId=' + ticketTypeId);
    }

    getCategoryListSupportGroupWiseForParentId(groupId, clientId, ticketTypeId, PARENT_ID) {
        return this.http.get(this.apiRoot + '/getCategoryListSupportGroupWiseForParentId?groupId=' + groupId + '&clientId=' +
            clientId + '&ticketTypeId=' + ticketTypeId + '&PARENT_ID=' + PARENT_ID);
    }

    getTicketCreateLoadingDtlsForSearch(user_id, ttype, clientId, cat1, cat2, supportGroupId, islead) {
        return this.http.get(this.apiRoot + '/getTicketCreateLoadingDtlsForSearch?user_id=' + user_id + '&ticket_type=' + ttype +
            '&clientId=' + clientId + '&cat1=' + cat1 + '&cat2=' + cat2 + '&groupId=' + supportGroupId + '&islead=' + islead);
    }

    searchTicketById(data) {
        return this.http.post(this.apiRoot + '/searchTicketById', data, httpOptions);
    }

    getUrlList() {
        return this.http.get(this.apiRoot + '/getUrlList');
    }

    addClientSpecificUrl(data) {
        return this.http.post(this.apiRoot + '/addClientSpecificUrl', data, httpOptions);
    }

    getClientSpecificUrl(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getClientSpecificUrl?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteClientSpecificUrl(data) {
        return this.http.post(this.apiRoot + '/deleteClientSpecificUrl', data, httpOptions);
    }

    getDistinctUrlKey(moduleId, user_id, clientId) {
        return this.http.get(this.apiRoot + '/getDistinctUrlKey?moduleId=' + moduleId + '&user_id=' + user_id + '&clientId=' + clientId);
    }

    getSscReport(startDate, endDate, clientId, ticketTypeId) {
        return this.http.get(this.apiRoot + '/getSscReport?fromDt=' + startDate + '&toDt=' + endDate + '&clientid=' + clientId +
            '&ticket_type=' + ticketTypeId);
    }

    getSscReportList(clientId, reportType) {
        return this.http.get(this.apiRoot + '/getSscReportList?clientId=' + clientId + '&reportType=' + reportType);
    }

    getMappedLeafMenu(clientId, moduleId) {
        return this.http.get(this.apiRoot + '/getMappedLeafMenu?clientId=' + clientId + '&moduleId=' + moduleId);
    }

    AdvancesearchForIncidentTicket(data) {
        return this.http.post(this.apiRoot + '/AdvancesearchForIncidentTicket', data, httpOptions);
    }

    getStatusByTicketTypeForIncident(ticket_type, clientId) {
        return this.http.get(this.apiRoot + '/getStatusByTicketTypeForIncident?ticketTypeSeqNo=' + ticket_type + '&clientId=' + clientId);
    }

    getFunctionalityByClient(clientId, funcId, refer_clientId) {
        return this.http.get(this.apiRoot + '/getFunctionalityByClient?clientId=' + clientId +
            '&funcId=' + funcId + '&refer_clientId=' + refer_clientId);
    }

    mapClientWiseFunctionality(data) {
        return this.http.post(this.apiRoot + '/mapClientWiseFunctionality', data, httpOptions);
    }

    getFunctionalityDetails(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getFunctionalityDetails?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    getTempSscReport(startDate, endDate, clientId, ticketTypeId) {
        return this.http.get(this.apiRoot + '/getTempSscReport?fromDt=' + startDate + '&toDt=' + endDate + '&clientid=' + clientId +
            '&ticket_type=' + ticketTypeId);
    }

    addChecklist(data) {
        return this.http.post(this.apiRoot + '/addChecklist', data, httpOptions);
    }

    getChecklist(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getChecklist?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteChecklist(data) {
        return this.http.post(this.apiRoot + '/deleteChecklist', data, httpOptions);
    }

    editChecklist(data) {
        return this.http.post(this.apiRoot + '/editChecklist', data, httpOptions);
    }

    insertEscalatePrcessConfig(data) {
        return this.http.post(this.apiRoot + '/insertEscalatePrcessConfig', data, httpOptions);
    }

    getEscalatePrcessConfig(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getEscalatePrcessConfig?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteEscalatePrcessConfig(data) {
        return this.http.post(this.apiRoot + '/deleteEscalatePrcessConfig', data, httpOptions);
    }

    getCsatRating(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getCsatRating?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    insertCsatRating(data) {
        return this.http.post(this.apiRoot + '/insertCsatRating', data, httpOptions);
    }

    deleteCsatRating(data) {
        return this.http.post(this.apiRoot + '/deleteCsatRating', data, httpOptions);
    }

    getCsatRatingList(clientId) {
        console.log('rating lis');
        return this.http.get(this.apiRoot + '/getCsatRatingList?clientId=' + clientId);
    }

    getCsatQuestion(clientId) {
        return this.http.get(this.apiRoot + '/getCsatQuestion?clientId=' + clientId);
    }

    editCsatRating(data) {
        return this.http.post(this.apiRoot + '/editCsatRating', data, httpOptions);
    }

    // ================================
    insertCsatQuestion(data) {
        return this.http.post(this.apiRoot + '/insertCsatQuestion', data, httpOptions);
    }

    deleteCsatQuestion(data) {
        return this.http.post(this.apiRoot + '/deleteCsatQuestion', data, httpOptions);
    }

    modifyCsatQuestion(data) {
        return this.http.post(this.apiRoot + '/modifyCsatQuestion', data, httpOptions);
    }

    getCsatQuestionList(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getCsatQuestionList?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    insertAutoTicket(data) {
        return this.http.post(this.apiRoot + '/insertAutoTicket', data, httpOptions);
    }

    deleteAutoTicket(data) {
        return this.http.post(this.apiRoot + '/deleteAutoTicket', data, httpOptions);
    }

    getAutoTicket(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getAutoTicket?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    editAutoTicket(data) {
        return this.http.post(this.apiRoot + '/editAutoTicket', data, httpOptions);
    }

    getChildTicketById(tId) {
        return this.http.get(this.apiRoot + '/getChildTicketById?tId=' + tId);
    }

    getAssetIdByTicket(tId) {
        return this.http.get(this.apiRoot + '/getAssetIdByTicket?tId=' + tId);
    }

    insertChildTicket(data) {
        return this.http.post(this.apiRoot + '/insertChildTicket', data, httpOptions);
    }

    insertTicketWiseCheckList(data) {
        return this.http.post(this.apiRoot + '/insertTicketWiseCheckList', data, httpOptions);
    }

    getCheckListDetails(clientId, status_sequence, categoryId) {
        return this.http.get(this.apiRoot + '/getCheckListDetails?clientId=' + clientId +
            '&status_sequence=' + status_sequence + '&category_id=' + categoryId);
    }

    AdvancesearchTicketForCit(data) {
        return this.http.post(this.apiRoot + '/AdvancesearchTicketForCit', data, httpOptions);
    }

    searchTicketByIdForCit(data) {
        return this.http.post(this.apiRoot + '/searchTicketByIdForCit', data, httpOptions);
    }

    deleteChildTicket(data) {
        return this.http.post(this.apiRoot + '/deleteChildTicket', data);
    }

    addAssetManagementAllValue(data) {
        return this.http.post(this.apiRoot + '/addAssetManagementAllValue', data, httpOptions);
    }

    getNewAssetDetailsByMaster(clientId, masterId) {
        return this.http.get(this.apiRoot + '/getNewAssetDetailsByMaster?clientId=' + clientId + '&masterId=' + masterId);
    }

    getAssetManagementDataTable(clientId, masterId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getAssetManagementDataTable?client_id=' + clientId + '&masterId='
            + masterId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    getParentTicketById(ticketId) {
        return this.http.get(this.apiRoot + '/getParentTicketById?ticketId=' + ticketId);
    }

    getAssetManagementReport(description, masterid, clientId) {
        return this.http.get(this.apiRoot + '/getAssetReport?description=' + description + '' +
            '&masterid=' + masterid + '&clientId=' + clientId);
    }

    getAssetReportDataTable(clientId) {
        return this.http.get(this.apiRoot + '/getAssetReportDataTable?clientId=' + clientId);
    }

    addAssetValidation(data) {
        return this.http.post(this.apiRoot + '/addAssetValidation', data, httpOptions);
    }

    allAssetValidation(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/allAssetValidation?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    editAssetValidation(data) {
        return this.http.post(this.apiRoot + '/editAssetValidation', data, httpOptions);
    }

    deleteAssetValidation(data) {
        return this.http.post(this.apiRoot + '/deleteAssetValidation', data, httpOptions);
    }

    getAssetColumnByMasterForValue(clientId, masterId) {
        return this.http.get(this.apiRoot + '/getAssetColumnByMasterForValue?clientId=' + clientId + '&masterId=' + masterId);
    }

    getAllLevelOneAndLevelTwoUser(clientId) {
        return this.http.get(this.apiRoot + '/getAllLevelOneAndLevelTwoUser?clientId=' + clientId);
    }

    updateAdditionalFieldValue(data) {
        return this.http.post(this.apiRoot + '/updateAdditionalFieldValue', data, httpOptions);
    }

    getAssetManagementTemplate(clientId) {
        return this.http.get(this.apiRoot + '/getAssetTemplate?clientId=' + clientId);
    }

    insertDashboard(data) {
        return this.http.post(this.apiRoot + '/insertDashboard', data, httpOptions);
    }

    getDashboardCategory(clientId, user_id, type = 'f') {
        return this.http.get(this.apiRoot + '/getDashboardCategory?clientId=' + clientId + '&user_id=' + user_id + '&type=' + type);
    }

    getSelectedDashboardCategory(clientId, user_id) {
        return this.http.get(this.apiRoot + '/getSelectedDashboardCategory?clientId=' + clientId + '&user_id=' + user_id);
    }

    getTicketCreateLoadingDtlsWithGroup(user_id, ttype, clientId, groupId) {
        return this.http.get(this.apiRoot + '/getTicketCreateLoadingDtlsWithGroup?user_id=' + user_id +
            '&ticket_type=' + ttype + '&clientId=' + clientId + '&groupId=' + groupId);
    }

    getCreateTicketDataWithGroup(user_id, ttype, clientId, groupId) {
        return this.http.get(this.apiRoot + '/getCreateTicketDataWithGroup?user_id=' + user_id +
            '&ticket_type=' + ttype + '&clientId=' + clientId + '&groupId=' + groupId);
    }

    getTicketCategoryTemplate(clientId, ticketType, enablePriority) {
        if (this.config.type === 'LOCAL') {
            return this.http.get(this.slaRoot + '/getCategoryTemplate?clientId=' + clientId + '&ticketType=' + ticketType +
                '&enablePriority=' + enablePriority);
        } else {
            return this.http.get(this.apiRoot + '/getCategoryTemplate?clientId=' + clientId + '&ticketType=' + ticketType +
                '&enablePriority=' + enablePriority);
        }
    }

    getCategoryByGroupForLnTCHR(clientId, ticketType, groupId) {
        return this.http.get(this.apiRoot + '/getCategoryByGroupForLnTCHR?clientId=' + clientId +
            '&ticket_type=' + ticketType + '&groupId=' + groupId);
    }

    getTicketAutoClosureTime(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getTicketAutoClosureTime?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    updateTicketAutoClosureTime(data) {
        return this.http.post(this.apiRoot + '/updateTicketAutoClosureTime', data, httpOptions);
    }

    insertTicketAutoClosureTime(data) {
        return this.http.post(this.apiRoot + '/insertTicketAutoClosureTime', data, httpOptions);
    }

    insertTicketFunc(data) {
        return this.http.post(this.apiRoot + '/insertTicketFunc', data, httpOptions);
    }

    updateTicketFunc(data) {
        return this.http.post(this.apiRoot + '/updateTicketFunc', data, httpOptions);
    }

    getTicketFunc(nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getTicketFunc?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteTicketFunc(data) {
        return this.http.post(this.apiRoot + '/deleteTicketFunc', data, httpOptions);
    }

    getDynamicTotCountMenuTicketDtls(clientId, groupId, ticketType, type, categoryId, userId, specialFilterVal = '0') {
        return this.http.get(this.apiRoot + '/getDynamicTotCountMenuTicketDtls?clientId=' + clientId + '&supportgrp_id=' +
            groupId + '&ticketTypeId=' + ticketType + '&type=' + type + '&catFilterVal=' + categoryId +
            '&userFilterVal=' + userId + '&specialFilterVal=' + specialFilterVal);
    }

    getMultipleAttributesParentWise(clientId, seq, lastId, limit, type = 'n') {
        return this.http.get(this.apiRoot + '/getMultipleAttributesParentWiseForLnTCHR?clientId=' +
            clientId + '&seq=' + seq + '&lastId=' + lastId + '&limit=' + limit + '&type=' + type);
    }

    getScheduleTicket(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getScheduleTicket?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    addEmailTicketKeyword(data) {
        return this.http.post(this.apiRoot + '/addEmailTicketKeyword', data, httpOptions);
    }

    allEmailTicketKeyword(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/allEmailTicketKeyword?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    editEmailTicketKeyword(data) {
        return this.http.post(this.apiRoot + '/editEmailTicketKeyword', data, httpOptions);
    }

    deleteEmailTicketKeyword(data) {
        return this.http.post(this.apiRoot + '/deleteEmailTicketKeyword', data, httpOptions);
    }

    getEmailTicketSenderType(clientId) {
        return this.http.get(this.apiRoot + '/getEmailTicketSenderType?client_id=' + clientId);
    }

    // New Api for Email Ticket
    getEmailTicketServiceUser(clientId) {
        return this.http.get(this.apiRoot + '/getEmailTicketServiceUser?clientId=' + clientId);
    }

    getEmailTicketCreateLoadingDtls(user_id, ttype, clientId) {
        return this.http.get(this.apiRoot + '/getEmailTicketCreateLoadingDtls?user_id=' + user_id + '' +
            '&ticket_type=' + ttype + '&clientId=' + clientId);
    }

    getEmailTicketFieldsCatWise(data) {
        return this.http.get(this.apiRoot + '/getEmailTicketFieldsCatWise?clientId=' + data.clientId + '' +
            '&catId=' + data.catId + '&ticketTypeId=' + data.ticketTypeId);
    }

    getEmailTicketAttributesParentWiseWithPriority(clientId, parentId, pType, tType) {
        return this.http.get(this.apiRoot + '/getEmailTicketAttributesParentWiseWithPriority?' +
            'clientId=' + clientId + '&parentId=' + parentId + '&pType=' + pType + '&tType=' + tType);
    }

    getEmailTicketBusinessPriorityTicketTypeWise(clientId, ticket_type) {
        return this.http.get(this.apiRoot + '/getEmailTicketBusinessPriorityTicketTypeWise?clientId='
            + clientId + '&ticket_type=' + ticket_type);
    }

    getChecklistQuestion(clientId, ticketId) {
        return this.http.get(this.apiRoot + '/getChecklistQuestion?clientId=' + clientId + '&ticketId=' + ticketId);
    }

    getAssetByTicket(ticketId) {
        return this.http.get(this.apiRoot + '/getAssetByTicket?ticketId=' + ticketId);
    }

    updateTicketAttributesClientWise(data) {
        return this.http.post(this.apiRoot + '/updateTicketAttributesClientWise', data, httpOptions);
    }

    updateTicketNotificationMst(data) {
        return this.http.post(this.apiRoot + '/updateTicketNotificationMst', data, httpOptions);
    }

    getTicketActivityMst() {
        return this.http.get(this.apiRoot + '/getTicketActivityMst');
    }

    insertTicketActivityNoficationMst(data) {
        return this.http.post(this.apiRoot + '/insertTicketActivityNoficationMst', data, httpOptions);
    }

    deleteTicketActivityNoficationMst(data) {
        return this.http.post(this.apiRoot + '/deleteTicketActivityNoficationMst', data, httpOptions);
    }

    getTicketActivityNoficationMst(nextOffset, pageSize, paginationType, clientId) {
        return this.http.get(this.apiRoot + '/getTicketActivityNoficationMst?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType + '&clientId=' + clientId);
    }

    getFileUploadLogs(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getFileUploadLogs?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType + '&clientId=' + clientId);
    }

    updateTicketMenuConfig(data) {
        return this.http.post(this.apiRoot + '/updateTicketMenuConfig', data, httpOptions);
    }

    PasswordChange(data) {
        return this.http.post(this.apiRoot + '/PasswordChange', data, httpOptions);
    }

    getAllRoles(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getAllRoles?client_id=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    updateTicketMenu(data) {
        return this.http.post(this.apiRoot + '/updateTicketMenu', data, httpOptions);
    }

    insertEscalationWorkflow(data) {
        return this.http.post(this.apiRoot + '/insertEscalationWorkflow', data, httpOptions);
    }

    deleteEscalationWorkflow(data) {
        return this.http.post(this.apiRoot + '/deleteEscalationWorkflow', data, httpOptions);
    }

    getEscalationWorkflow(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getEscalationWorkflow?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    generateTempSscReport(data) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.reportRoot + '/lntReportTempExcel', data, httpOptions);
        } else {
            return this.http.post(this.apiRoot + '/generateTempSscReport', data, httpOptions);
        }
    }

    generateSscReport(data) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.reportRoot + '/lntReportInDetailsExcel', data, httpOptions);
        } else {
            return this.http.post(this.apiRoot + '/generateSscReport', data, httpOptions);
        }
    }

    getPriorityClientWise(clientId, ticketTypeId) {
        return this.http.get(this.apiRoot + '/getPriorityClientWise?clientId=' + clientId + '&ticketTypeId=' + ticketTypeId);
    }

    searchUserDetails(clientId, psOrName) {
        return this.http.get(this.apiRoot + '/searchUserDetails?clientId=' + clientId + '&psOrName=' + psOrName);
    }

    generateTempCitReport(data) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.reportRoot + '/lntCitReportTempExcel', data, httpOptions);
        } else {
            return this.http.post(this.apiRoot + '/generateTempCitReport', data, httpOptions);
        }
    }

    generateCitReport(data) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.reportRoot + '/lntCitReportInDetailsExcel', data, httpOptions);
        } else {
            return this.http.post(this.apiRoot + '/generateCitReport', data, httpOptions);
        }
    }

    generateTempChrReport(data) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.reportRoot + '/lntChrReportTempExcel', data, httpOptions);
        } else {
            return this.http.post(this.apiRoot + '/generateTempChrReport', data, httpOptions);
        }
    }

    generateChrReport(data) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.reportRoot + '/lntChrReportInDetailsExcel', data, httpOptions);
        } else {
            return this.http.post(this.apiRoot + '/generateChrReport', data, httpOptions);
        }
    }

    // createTicketCR(data) {
    //     return this.http.post(this.apiRoot + '/createTicketCR', data, httpOptions);
    // }

    getTicketByPlannedDateTime(planned_start_dt, planned_end_dt, clientId) {
        return this.http.get(this.apiRoot + '/getTicketByPlannedDateTime?planned_start_dt=' + planned_start_dt +
            '&planned_end_dt=' + planned_end_dt + '&clientId=' + clientId);
    }

    getAdditionalFieldTypeList(clientId) {
        return this.http.get(this.apiRoot + '/getAdditionalFieldTypeList?clientId=' + clientId);
    }

    getSLAComplainceReport(clientId, type, filter, fromDate, toDate, tillDate, ticketType) {
        return this.http.get(this.apiRoot + '/getSLAComplainceReport?clientId=' + clientId + '&type=' + type + '&filter=' +
            filter + '&fromdate=' + fromDate + '&todate=' + toDate + '&tillDate=' + tillDate + '&ticketType=' + ticketType);
    }

    getEscalationReport(clientId, type, filter, fromDate, toDate, tillDate, ticketType) {
        return this.http.get(this.apiRoot + '/getEscalationReport?clientId=' + clientId + '&type=' + type + '&filter=' +
            filter + '&fromdate=' + fromDate + '&todate=' + toDate + '&tillDate=' + tillDate + '&ticketType=' + ticketType);
    }

    getProductivityReport(clientId, type, filter, fromDate, toDate, tillDate, team) {
        return this.http.get(this.apiRoot + '/getProductivityReport?clientId=' + clientId + '&type=' + type + '&filter=' +
            filter + '&fromdate=' + fromDate + '&todate=' + toDate + '&tillDate=' + tillDate + '&team=' + team);
    }

    getProductivityTeam(clientId) {
        return this.http.get(this.apiRoot + '/getProductivityTeam?clientId=' + clientId);
    }

    getCSATReport(clientId, type, filter, fromDate, toDate, tillDate, ticketType) {
        return this.http.get(this.apiRoot + '/getCSATReport?clientId=' + clientId + '&type=' + type + '&filter=' + filter +
            '&fromdate=' + fromDate + '&todate=' + toDate + '&tillDate=' + tillDate + '&ticketType=' + ticketType);
    }

    getTicketByIdMinimal(data) {
        return this.http.get(this.apiRoot + '/getTicketByIdMinimal?clientId=' + data.clientId + '&ticketId=' + data.ticketId);
    }

    getPlannedDateTimeByTicketId(clientId, ticketId) {
        return this.http.get(this.apiRoot + '/getPlannedDateTimeByTicketId?clientId=' + clientId + '&ticketId=' + ticketId);
    }

    getTrendReport(clientId, type, filter, fromDate, toDate, tillDate, ticketType, xScale, tStatus) {
        return this.http.get(this.apiRoot + '/getTrendReport?clientId=' + clientId + '&type=' +
            type + '&filter=' + filter + '&fromdate=' + fromDate + '&todate=' + toDate + '&tillDate=' +
            tillDate + '&ticketType=' + ticketType + '&xScale=' + xScale + '&ticketStatus=' + tStatus);
    }


    getSupportGroupLevelWise(clientId, grpLevel, userGroupId) {
        return this.http.get(this.apiRoot + '/getSupportGroupLevelWise?clientId=' + clientId + '&grpLevel=' +
            grpLevel + '&userGroupId=' + userGroupId);
    }

    getSupportGroupByLevelWise(clientId, grpLevel) {
        return this.http.get(this.apiRoot + '/getSupportGroupByLevelWise?clientId=' + clientId + '&grpLevel=' +
            grpLevel);
    }
    

    getUserByGroupCHR(clientId, groupId, FinalCategory) {
        return this.http.get(this.apiRoot + '/getUserByGroupCHR?clientId=' + clientId + '&groupId=' + groupId +
            '&FinalCategory=' + FinalCategory);
    }

    getUserByGroup1CHR(clientId, groupId, FinalCategory, referId, user_id) {
        return this.http.get(this.apiRoot + '/getUserByGroup1CHR?clientId=' + clientId + '&groupId=' + groupId +
            '&FinalCategory=' + FinalCategory +
            '&user_id=' + user_id + '&referId=' + referId);
    }

    mapPsnoWithGroup(data) {
        return this.http.post(this.apiRoot + '/mapPsnoWithGroup', data, httpOptions);
    }

    getSupportGroupUserMappingCategoryWise(clientId, nextOffset, pageSize, paginationType, grpLevel, userGroupId) {
        return this.http.get(this.apiRoot + '/getSupportGroupUserMappingCategoryWise?clientId=' + clientId +
            '&nextOffset=' + nextOffset + '&page_size=' + pageSize + '&paginationType=' + paginationType +
            '&grpLevel=' + grpLevel + '&userGroupId=' + userGroupId);
    }

    faqSearchKeywordforDocs(clientId, value, user_id) {
        if (this.config.type === 'LOCAL') {
            return this.http.get(this.indexRoot + '/faqSearchKeywordforDocs?clientId=' + clientId + '&user_id=' + user_id + '&searchKeyword=' +
                value);
        } else {
            return this.http.get(this.apiRoot + '/faqSearchKeywordforDocs?clientId=' + clientId + '&user_id=' + user_id + '&searchKeyword=' +
                value);
        }
    }

    getTicketStatusForCHRselfAssign(tId) {
        return this.http.get(this.apiRoot + '/getTicketStatusForCHRselfAssign?tId=' + tId);
    }

    getTicketCreateLoadingDtls_lntchr(user_id, ttype, clientId) {
        return this.http.get(this.apiRoot + '/getTicketCreateLoadingDtls_lntchr?ref_user_id=' + user_id + '&ticket_type=' + ttype +
            '&clientId=' + clientId);
    }

    getTicketCategoryDetails_lntchr(clientId, id, typeId, disableField, createbyid, suppGrpId = null, working_category = null) {
        return this.http.get(this.apiRoot + '/getTicketCategoryDetails_lntchr?clientId=' + clientId + '&ticketId='
            + id + '&typeId=' + typeId + '&disableField=' + disableField + '&createbyid=' + createbyid + '&suppGrpId=' + suppGrpId +
            '&cat_id=' + working_category);
    }

    getHeatmapReport(clientId, type, filter, maxSla, ticketType) {
        return this.http.get(this.apiRoot + '/getHeatmapReport?clientId=' + clientId + '&type=' + type +
            '&filter=' + filter + '&maxSla=' + maxSla + '&ticketType=' + ticketType);
    }

    getUserGroupRoleDetails(clientId, nextOffset, pageSize, paginationType, supportGroupId) {
        return this.http.get(this.apiRoot + '/getUserGroupRoleDetails?clientId=' + clientId +
            '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType + '&supportGroupId=' + supportGroupId);
    }

    getTrendBarReport(clientId, type, typeValue, filter) {
        return this.http.get(this.apiRoot + '/getTrendBarReport?clientId=' + clientId + '&type=' + type +
            '&typeValue=' + typeValue + '&filter=' + filter);
    }

    getReportCategory(clientId, ticketType) {
        return this.http.get(this.apiRoot + '/getReportCategory?clientId=' + clientId + '&ticketType=' + ticketType);
    }

    searchAllUser(clientId, psOrName, role_id) {
        return this.http.get(this.apiRoot + '/searchAllUser?clientId=' + clientId + '&psOrName=' + psOrName + '&roleId=' + role_id);
    }

    getCategoryGroupMapping(clientId, nextOffset, pageSize, paginationType, supportGroupId) {
        return this.http.get(this.apiRoot + '/getCategoryGroupMapping?clientId=' + clientId +
            '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType + '&supportGroupId=' + supportGroupId);
    }

    getCatfromUrl(clientId, ticket_type2, cat1, cat2, cat3) {
        return this.http.get(this.apiRoot + '/getCatfromUrl?clientId=' + clientId + '&ticket_type2=' +
            ticket_type2 + '&cat1=' + cat1 + '&cat2=' + cat2 + '&cat3=' + cat3);
    }

    getTicketCreateLoadingDtls_citapps(user_id, ticket_type, clientId, cat1, cat2, cat3) {
        return this.http.get(this.apiRoot + '/getTicketCreateLoadingDtls_citapps?clientId=' + clientId + '&ticket_type=' +
            ticket_type + '&cat1=' + cat1 + '&cat2=' + cat2 + '&cat3=' + cat3 + '&user_id=' + user_id);
    }

    getReportStatus(clientId) {
        return this.http.get(this.apiRoot + '/getReportStatus?clientId=' + clientId);
    }

    getReportFilters(clientId, reportType) {
        return this.http.get(this.apiRoot + '/getReportFilters?clientId=' + clientId + '&reportType=' + reportType);
    }

    getstatusSeqData(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getstatusSeqData?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    addStatusSeq(data) {
        return this.http.post(this.apiRoot + '/addStatusSeq', data, httpOptions);
    }

    deleteStatusSeq(data) {
        return this.http.post(this.apiRoot + '/deleteStatusSeq', data, httpOptions);
    }

    getSupportGroupNotMapInCatagory(clientId) {
        return this.http.get(this.apiRoot + '/getSupportGroupNotMapInCatagory?clientId=' + clientId);
    }

    getAttrHeader(clientId) {
        return this.http.get(this.apiRoot + '/getAttrHeader?clientId=' + clientId);
    }

    getLntChrEndUser(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getLntChrEndUser?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    insertMappingCategoryWithSupportGrp(data) {
        return this.http.post(this.apiRoot + '/insertMappingCategoryWithSupportGrp', data, httpOptions);
    }

    getSubClient(clientId) {
        return this.http.get(this.apiRoot + '/getSubClient?clientId=' + clientId);
    }

    getHolidayBySupGrp(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getHolidayBySupGrp?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    getSLAClientWiseDetailsBySupGrp(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSLAClientWiseDetailsBySupGrp?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    generateCitAppsReport(data) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.reportRoot + '/lntCitAppsReportInDetailsExcel', data, httpOptions);
        } else {
            return this.http.post(this.apiRoot + '/generateCitAppsReport', data, httpOptions);
        }
    }

    generateTempCitAppsReport(data) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.reportRoot + '/lntCitAppsReportTempExcel', data, httpOptions);
        } else {
            return this.http.post(this.apiRoot + '/generateTempCitAppsReport', data, httpOptions);
        }
    }

    getColumListByTableName(clientId, tableName) {
        return this.http.get(this.apiRoot + '/getColumListByTableName?clientId=' + clientId + '&table=' + tableName);
    }

    addReportConfiguratorTemplate(data) {
        return this.http.post(this.apiRoot + '/addReportConfiguratorTemplate', data, httpOptions);
    }

    getReportConfiguratorTemplateList(clientId) {
        return this.http.get(this.apiRoot + '/getReportConfiguratorTemplateList?clientId=' + clientId);
    }

    getUniqueValueByField(clientId, fieldName, tableName) {
        return this.http.get(this.apiRoot + '/getUniqueValueByField?clientId=' + clientId + '&fieldName=' + fieldName + '&tableName=' + tableName);
    }

    getReportTableData(clientId, template_id) {
        return this.http.get(this.apiRoot + '/getReportTableData?clientId=' + clientId + '&template_id=' + template_id);
    }

    getStagingTableList(clientId) {
        return this.http.get(this.apiRoot + '/getStagingTableList?clientId=' + clientId);
    }

    checkSupportGroupManagerialView(groupId) {
        return this.http.get(this.apiRoot + '/checkSupportGroupManagerialView?supportgrp_id=' + groupId);
    }

    // =================
    getSlaCalculation(clientId) {
        return this.http.get(this.apiRoot + '/getSlaCalculation?clientId=' + clientId);
    }

    insertSlaCalculation(data) {
        return this.http.post(this.apiRoot + '/insertSlaCalculation', data, httpOptions);
    }

    deleteSlaCalculation(data) {
        return this.http.post(this.apiRoot + '/deleteSlaCalculation', data, httpOptions);
    }

    getSlaCalculationDoneByList(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSlaCalculationDoneByList?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    getLatestWFCRId(ticketId) {
        return this.http.get(this.apiRoot + '/getLatestWFCRId?ticketId=' + ticketId);
    }

    getClientWiseSlaClient(clientId, ticket_type, priority) {
        return this.http.get(this.apiRoot + '/getClientWiseSlaClient?clientId=' + clientId + '&TICKETTYPEID=' + ticket_type +
            '&busi_priority_id=' + priority);
    }

    getTicketDetail(ticketId) {
        return this.http.get(this.apiRoot + '/getTicketDetail?id=' + ticketId);
    }

    deleteFaqDocumentLog(data) {
        return this.http.post(this.apiRoot + '/deleteFaqDocumentLog', data, httpOptions);
    }

    getFaqDocumentLog(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getFaqDocumentLog?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    insertFaqDocumentLog(data) {
        return this.http.post(this.apiRoot + '/insertFaqDocumentLog', data, httpOptions);
    }

    getClietSpecificUrl(clientId) {
        return this.http.get(this.apiRoot + '/getClietSpecificUrl?clientId=' + clientId);
    }

    addSupportGroupSpecificUrl(data) {
        return this.http.post(this.apiRoot + '/addSupportGroupSpecificUrl', data, httpOptions);
    }

    getActiveCategoryDetails(ticketId) {
        return this.http.get(this.apiRoot + '/getActiveCategoryDetails?ticketId=' + ticketId);
    }

    getSupportGroupSpecificUrl(nextOffset, pageSize, paginationType, clientId) {
        return this.http.get(this.apiRoot + '/getSupportGroupSpecificUrl?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType + '&clientId=' + clientId);
    }

    getUrlBySupportGroup(clientId, supportGroupId, ticketTypeId) {
        return this.http.get(this.apiRoot + '/getUrlBySupportGroup?clientId=' + clientId + '&supportGroupLevelId=' + supportGroupId +
            '&ticketTypeId=' + ticketTypeId);
    }

    getAnyTicketById(data) {
        return this.http.get(this.apiRoot + '/getAnyTicketById?clientId=' + data.clientId + '&ticketId=' + data.ticketId);
    }

    getTicketDetailsById(data) {
        return this.http.get(this.apiRoot + '/getTicketDetailsById?clientId=' + data.clientId + '&ticketId=' + data.ticketId);
    }


    searchTicketByIdForChr(data) {
        return this.http.post(this.apiRoot + '/searchTicketByIdForChr', data, httpOptions);
    }


    searchUserDetailsByPsNo(clientId, psNo) {
        return this.http.get(this.apiRoot + '/searchUserDetailsByPsNo?clientId=' + clientId + '&psNo=' + psNo);
    }

    addNotification(data) {
        return this.http.post(this.apiRoot + '/addNotification', data, httpOptions);
    }

    deleteNotification(data) {
        return this.http.post(this.apiRoot + '/deleteNotification', data, httpOptions);
    }

    getNotifiationMaster(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getNotifiationMaster?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    searchAnalystByPsNo(clientId, psNo) {
        return this.http.get(this.apiRoot + '/searchAnalystByPsNo?clientId=' + clientId + '&psNo=' + psNo);
    }

    updateClient(data) {
        return this.http.post(this.apiRoot + '/updateClient', data, httpOptions);
    }

    // ================= sutirtha----------------------------------------
    // searchAllCategory(name,clientId ) {
    //     return this.http.get(this.apiRoot + '/searchAllCategory?name=' + name +'&clientId='+clientId);
    // }
    searchAllClient(psOrName, clientId) {
        return this.http.get(this.apiRoot + '/searchAllClient?name=' + psOrName + '&clientId=' + clientId);
    }

    searchAllCreateMenu(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllCreateMenu?name=' + name + '&clientId=' + clientId);
    }

    searchAllModuleRoleMap(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllModuleRoleMap?name=' + name + '&clientId=' + clientId);
    }

    searchAllSupportGroupHolidays(date, clientId) {
        return this.http.get(this.apiRoot + '/searchAllSupportGroupHolidays?date=' + date + '&clientId=' + clientId);
    }

    searchAllSupportGroupSlaClient(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllSupportGroupSlaClient?name=' + name + '&clientId=' + clientId);
    }

    searchAllCategorySlaMap(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllCategorySlaMap?name=' + name + '&clientId=' + clientId);
    }

    searchAllLevelOfCategories(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllLevelOfCategories?name=' + name + '&clientId=' + clientId);
    }

    searchAllMapClientWithCategoryLevel(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllMapClientWithCategoryLevel?name=' + name + '&clientId=' + clientId);
    }

    searchAllMapCategoryWithGroup(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllMapCategoryWithGroup?name=' + name + '&clientId=' + clientId);
    }

    searchAllReportFields(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllReportFields?name=' + name + '&clientId=' + clientId);
    }

    searchAllViewTicketMenuConfiguration(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllViewTicketMenuConfiguration?name=' + name + '&clientId=' + clientId);
    }

    searchAllBusinessImpact(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllBusinessImpact?name=' + name + '&clientId=' + clientId);
    }

    searchAllBusinessUrgency(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllBusinessUrgency?name=' + name + '&clientId=' + clientId);
    }

    searchAllPriority(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllPriority?name=' + name + '&clientId=' + clientId);
    }

    searchAllSlaClient(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllSlaClient?name=' + name + '&clientId=' + clientId);
    }

    searchAllBusinessMatrix(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllBusinessMatrix?name=' + name + '&clientId=' + clientId);
    }

    searchAllStatus(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllStatus?name=' + name + '&clientId=' + clientId);
    }

    searchAllStasearchAllEscalationtus(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllEscalation?name=' + name + '&clientId=' + clientId);
    }

    searchAllFollowUp(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllFollowUp?name=' + name + '&clientId=' + clientId);
    }

    searchAllFileUploadLogs(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllFileUploadLogs?name=' + name + '&clientId=' + clientId);
    }

    searchAllTicketCheckList(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllTicketCheckList?name=' + name + '&clientId=' + clientId);
    }

    searchAllEscalateMaster(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllEscalateMaster?name=' + name + '&clientId=' + clientId);
    }

    searchAllAutoTicketConfig(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllAutoTicketConfig?name=' + name + '&clientId=' + clientId);
    }

    // (rechek)
    searchAllTicketStatusFlow(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllTicketStatusFlow?name=' + name + '&clientId=' + clientId);
    }

    searchAllModule(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllModule?name=' + name + '&clientId=' + clientId);
    }

    searchAllModulePageUrlMapping(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllModulePageUrlMapping?name=' + name + '&clientId=' + clientId);
    }

    searchAllModulePageUrlMappingStupa(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllModulePageUrlMappingStupa?name=' + name + '&clientId=' + clientId);
    }

    searchAllMapRoleWithUser(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllMapRoleWithUser?name=' + name + '&clientId=' + clientId);
    }

    searchAllRoleMapping(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllRoleMapping?name=' + name + '&clientId=' + clientId);
    }

    searchAllClientAdminRoleMapping(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllClientAdminRoleMapping?name=' + name + '&clientId=' + clientId);
    }

    searchAllRoleActionMapping(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllRoleActionMapping?name=' + name + '&clientId=' + clientId);
    }

    searchAllRoleUserActionMapping(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllRoleUserActionMapping?name=' + name + '&clientId=' + clientId);
    }

    searchAllModuleUserRoleMapping(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllModuleUserRoleMapping?name=' + name + '&clientId=' + clientId);
    }

    searchAllMenuConfiguration(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllMenuConfiguration?name=' + name + '&clientId=' + clientId);
    }


    searchAllRoles(name, createdBy) {
        return this.http.get(this.apiRoot + '/searchAllRoles?name=' + name + '&createbyid=' + createdBy);
    }

    searchAllRoleActionMap(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllRoleActionMap?name=' + name + '&clientId=' + clientId);
    }

    searchAllSupportGroup(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllSupportGroup?name=' + name + '&clientId=' + clientId);
    }

    searchAllModuleRoleUserMap(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllModuleRoleUserMap?name=' + name + '&clientId=' + clientId);
    }

    searchAllMapUserWithSupportGroup(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllMapUserWithSupportGroup?name=' + name + '&clientId=' + clientId);
    }

    // ================= excel export==========================

    getAllLevelOfCategories(clientId) {
        return this.http.get(this.apiRoot + '/getAllLevelOfCategories?clientId=' + clientId);
    }

    getAllCategory(clientId) {
        return this.http.get(this.apiRoot + '/getAllCategory?clientId=' + clientId);
    }

    getAllMapClientWithCategoryLevel(clientId) {
        return this.http.get(this.apiRoot + '/getAllMapClientWithCategoryLevel?clientId=' + clientId);
    }

    getAllMapCategoryWithGroup(clientId) {
        return this.http.get(this.apiRoot + '/getAllMapCategoryWithGroup?clientId=' + clientId);
    }

    getAllReportFields(clientId) {
        return this.http.get(this.apiRoot + '/getAllReportFields?clientId=' + clientId);
    }

    getAllViewTicketMenuConfiguration(clientId) {
        return this.http.get(this.apiRoot + '/getAllViewTicketMenuConfiguration?clientId=' + clientId);
    }

    getAllBusinessImpact(clientId) {
        return this.http.get(this.apiRoot + '/getAllBusinessImpact?clientId=' + clientId);
    }

    getAllBusinessUrgency(clientId) {
        return this.http.get(this.apiRoot + '/getAllBusinessUrgency?clientId=' + clientId);
    }

    getAllPriority(clientId) {
        return this.http.get(this.apiRoot + '/getAllPriority?clientId=' + clientId);
    }

    getAllSupportGroupData(clientId) {
        return this.http.get(this.apiRoot + '/getAllSupportGroupData?clientId=' + clientId);
    }

    getAllRoleData(clientId) {
        return this.http.get(this.apiRoot + '/getAllRoleData?clientId=' + clientId);
    }

    getAllSlaClient(clientId) {
        return this.http.get(this.apiRoot + '/getAllSlaClient?clientId=' + clientId);
    }

    getAllBusinessMatrix(clientId) {
        return this.http.get(this.apiRoot + '/getAllBusinessMatrix?clientId=' + clientId);
    }

    getAllStatus(clientId) {
        return this.http.get(this.apiRoot + '/getAllStatus?clientId=' + clientId);
    }

    getAllFollowUp(clientId) {
        return this.http.get(this.apiRoot + '/getAllFollowUp?clientId=' + clientId);
    }

    getAllFileUploadLogs(clientId) {
        return this.http.get(this.apiRoot + '/getAllFileUploadLogs?clientId=' + clientId);
    }

    getAllTicketCheckList(clientId) {
        return this.http.get(this.apiRoot + '/getAllTicketCheckList?clientId=' + clientId);
    }

    getAllEscalateMaster(clientId) {
        return this.http.get(this.apiRoot + '/getAllEscalateMaster?clientId=' + clientId);
    }

    getAllMapUserWithSupportGroup(clientId) {
        return this.http.get(this.apiRoot + '/getAllMapUserWithSupportGroup?clientId=' + clientId);
    }

    getAllModuleRoleMap(clientId) {
        return this.http.get(this.apiRoot + '/getAllModuleRoleMap?clientId=' + clientId);
    }

    getAllSupportGroupHolidays(clientId) {
        return this.http.get(this.apiRoot + '/getAllSupportGroupHolidays?clientId=' + clientId);
    }

    getAllEscalation(clientId) {
        return this.http.get(this.apiRoot + '/getAllEscalation?clientId=' + clientId);
    }

    updateFlowStatus(data) {
        return this.http.post(this.apiRoot + '/updateFlowStatus', data, httpOptions);
    }

    getAllUserandSupportGroup(clientId) {
        return this.http.get(this.apiRoot + '/getAllUserandSupportGroup?clientId=' + clientId);
    }

    getAllCategoryandSupportGroup(clientId) {
        return this.http.get(this.apiRoot + '/getAllCategoryandSupportGroup?clientId=' + clientId);
    }

    getAllModulePageUrl(clientId) {
        return this.http.get(this.apiRoot + '/getAllModulePageUrl?clientId=' + clientId);
    }

    getAllMenus(clientId) {
        return this.http.get(this.apiRoot + '/getAllMenus?clientId=' + clientId);
    }

    getAllUrlWithMenus(clientId) {
        return this.http.get(this.apiRoot + '/getAllUrlWithMenus?clientId=' + clientId);
    }

    searchAllPlatformUserAuth(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllPlatformUserAuth?name=' + name + '&clientId=' + clientId);
    }

    getAllClientStatus(clientId) {
        return this.http.get(this.apiRoot + '/getAllClientStatus?clientId=' + clientId);
    }

    searchAllClientStatus(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllClientStatus?name=' + name + '&clientId=' + clientId);
    }

    getAllClientSpecificUrl(clientId) {
        return this.http.get(this.apiRoot + '/getAllClientSpecificUrl?clientId=' + clientId);
    }

    searchAllClientSpecificUrl(name, clientId) {
        return this.http.get(this.apiRoot + '/searchAllClientSpecificUrl?name=' + name + '&clientId=' + clientId);
    }

    getAllBackwardWorkflow(clientId) {
        return this.http.get(this.apiRoot + '/getAllBackwardWorkflow?clientId=' + clientId);
    }

    getAllForwardWorkflow(clientId, indicator) {
        return this.http.get(this.apiRoot + '/getAllForwardWorkflow?clientId=' + clientId + '&indicator=' + indicator);
    }

    getAllModulePageUrlMapping(clientId) {
        return this.http.get(this.apiRoot + '/getAllModulePageUrlMapping?clientId=' + clientId);
    }

    faqMasterIndex() {
        return this.http.get(this.indexRoot + '/faqIndexForDB');
    }

    faqDocumentIndex() {
        if (this.config.type === 'LOCAL') {
            return this.http.get(this.indexRoot + '/faqIndexFromS3');
        } else {
            return this.http.get(this.apiRoot + '/faqIndexFromS3');
        }
    }

    searchSupportGroupUserMappingCategoryWise(grpLevel, userGroupId, loginName, clientId) {
        return this.http.get(this.apiRoot + '/searchSupportGroupUserMappingCategoryWise?clientId=' + clientId +
            '&grpLevel=' + grpLevel + '&userGroupId=' + userGroupId + '&loginName=' + loginName);
    }

    getCountQuery(clientId, menuId) {
        return this.http.get(this.apiRoot + '/searchSupportGroupUserMappingCategoryWise?clientId=' + clientId +
            '&menuId=' + menuId);
    }

    getSubClientType(clientId) {
        return this.http.get(this.apiRoot + '/getSubClientType?clientId=' + clientId);
    }

    deleteSupportGroupSpecificUrl(data) {
        return this.http.post(this.apiRoot + '/deleteSupportGroupSpecificUrl', data, httpOptions);
    }

    getSupportGroupByClientIdOrMasterClientId(clientId) {
        return this.http.get(this.apiRoot + '/getSupportGroupByClientIdOrMasterClientId?clientId=' + clientId);
    }

    getTicketCategoryDetailsDynamic(clientId, id, typeId, suppGrpId = null, working_category = null) {
        return this.http.get(this.apiRoot + '/getTicketCategoryDetailsDynamic?clientId=' + clientId + '&ticketId='
            + id + '&typeId=' + typeId + '&suppGrpId=' + suppGrpId + '&cat_id=' + working_category);
    }

    AdvancesearchIncidentTicket(data) {
        return this.http.post(this.apiRoot + '/AdvancesearchIncidentTicket', data, httpOptions);
    }

    getIncidentTicketTypeId(clientId) {
        return this.http.get(this.apiRoot + '/getIncidentTicketTypeId?clientId=' + clientId);
    }

    getDynamicTotCountMenuTicketDtls_new(clientId, groupId, ticketType, seq, type, categoryId, userId, specialFilterVal = '0') {
        return this.http.get(this.apiRoot + '/getDynamicTotCountMenuTicketDtls_new?clientId=' + clientId + '&supportgrp_id=' +
            groupId + '&ticketTypeId=' + ticketType + '&type=' + type + '&catFilterVal=' + categoryId +
            '&userFilterVal=' + userId + '&specialFilterVal=' + specialFilterVal + '&seq=' + seq);
    }

    getDynamicTotCountMenuTicketDtls_updated(clientId, groupId, ticketType, seq, type, categoryId, userId, roleId, specialFilterVal = '0') {
        return this.http.get(this.apiRoot + '/getDynamicTotCountMenuTicketDtls_new?clientId=' + clientId + '&supportgrp_id=' +
            groupId + '&ticketTypeId=' + ticketType + '&type=' + type + '&catFilterVal=' + categoryId +
            '&userFilterVal=' + userId + '&specialFilterVal=' + specialFilterVal + '&seq=' + seq + '&roleId=' + roleId);
    }

    getDynamicMenuTicketDtls_new(data) {
        return this.http.get(this.apiRoot + '/getDynamicMenuTicketDtls_new?' +
            'user_id=' + data.user_id + '&ticketTypeId=' + data.ticketTypeId +
            '&seq=' + data.seq + '&supportgrp_id=' + data.supportgrp_id +
            '&clientId=' + data.clientId + '&menuId=' + data.menuId + '&userFilterVal=' + data.userFilterVal +
            '&catFilterVal=' + data.catFilterVal + '&nextOffset=' + data.nextOffset + '&page_size='
            + data.page_size + '&specialFilterVal=' + data.specialFilterVal +
            '&paginationType=' + data.paginationType + '&isLNTSSC=' + data.isLNTSSC);
    }

    getDynamicMenuTicketDtls_updated(data) {
        return this.http.get(this.apiRoot + '/getDynamicMenuTicketDtls_new?' +
            'user_id=' + data.user_id + '&ticketTypeId=' + data.ticketTypeId +
            '&seq=' + data.seq + '&supportgrp_id=' + data.supportgrp_id +
            '&clientId=' + data.clientId + '&menuId=' + data.menuId + '&userFilterVal=' + data.userFilterVal +
            '&catFilterVal=' + data.catFilterVal + '&nextOffset=' + data.nextOffset + '&page_size='
            + data.page_size + '&specialFilterVal=' + data.specialFilterVal +
            '&paginationType=' + data.paginationType + '&isLNTSSC=' + data.isLNTSSC + '&roleId=' + data.roleId);
    }

    getAllSupportGroupUserMap(clientId, grpLevel, userGroupId) {
        return this.http.get(this.apiRoot + '/getAllSupportGroupUserMap?clientId=' + clientId + '&grpLevel=' + grpLevel + '&userGroupId=' + userGroupId);
    }

    getCategoryReportUserWise(clientId, selectedUserId) {
        return this.http.get(this.apiRoot + '/getCategoryReportUserWise?clientId=' + clientId + '&selectedUserId=' + selectedUserId);
    }

    getCategoryReportSupportGroupWise(clientId, supportGroupIds) {
        return this.http.get(this.apiRoot + '/getCategoryReportSupportGroupWise?clientId=' + clientId + '&supportGroupIds=' + supportGroupIds);
    }

    getUserSupportGroup(clientId) {
        return this.http.get(this.apiRoot + '/getUserSupportGroup?clientId=' + clientId);
    }

    insertEmailFeedback(data) {
        return this.http.post(this.apiRoot + '/insertEmailFeedback', data);
    }

    insertSedularConfig(data) {
        return this.http.post(this.apiRoot + '/insertSedularConfig', data, httpOptions);
    }

    insertEmailConfig(data) {
        return this.http.post(this.apiRoot + '/insertEmailConfig', data, httpOptions);
    }

    deleteSedularConfig(data) {
        return this.http.post(this.apiRoot + '/deleteSedularConfig', data, httpOptions);
    }

    getSlaViolationMaster(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getSlaViolationMaster?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    updateSlaViolationMaster(data) {
        return this.http.post(this.apiRoot + '/updateSlaViolationMaster', data, httpOptions);
    }

    getSupportGroupCount(clientId) {
        return this.http.get(this.apiRoot + '/getSupportGroupCount?clientId=' + clientId);
    }

    generateCitHReport(data) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.reportRoot + '/lntCitImsHybridReportTempExcel', data, httpOptions);
        } else {
            return this.http.post(this.apiRoot + '/generateCitHybridReport', data, httpOptions);
        }
    }

    generateCitAppsHReport(data) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.reportRoot + '/lntCitAppsHybridReportTempExcel', data, httpOptions);
        } else {
            return this.http.post(this.apiRoot + '/generateCitAppsHybridReport', data, httpOptions);
        }
    }

    downloadFile(clientId, newname, type) {
        return this.http.get(this.apiRoot + '/downloadFile?clientId=' + clientId + '&type=' + type + '&newname=' + newname);
    }

    getBRAIOurl(clientId, ticket_type, catId) {
        return this.http.get(this.apiRoot + '/getBRAIOurl?clientId=' + clientId + '&ticket_type=' + ticket_type + '&catId=' + catId);
    }

    getLastLevelCategoryByTicketType(clientId, ticketId) {
        return this.http.get(this.apiRoot + '/getLastLevelCategoryByTicketType?clientId=' + clientId + '&ticket_type=' + ticketId);
    }


    deleteBraioMapping(data) {

        return this.http.post(this.apiRoot + '/deleteBraioMapping', data, httpOptions);
    }

    insertBraioMapping(data) {
        return this.http.post(this.apiRoot + '/insertBraioMapping', data, httpOptions);
    }


    updateBraioMapping(data) {
        return this.http.post(this.apiRoot + '/updateBraioMapping', data, httpOptions);
    }

    getallBraioMapping(clientId, nextOffset, pageSize, paginationType) {
        return this.http.get(this.apiRoot + '/getallBraioMapping?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType);
    }

    createAndModifiedUser(data) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.userUploadApiRoot + '/bulkUserCreationAndModification', data, httpOptions);
        } else {
            return this.http.post(this.apiRoot + '/bulkUserCreationAndModification', data, httpOptions);
        }
    }

    deleteDashboardCat(data) {
        return this.http.post(this.apiRoot + '/deleteDashboardCat', data, httpOptions);
    }

    insertDashboardCat(data) {
        return this.http.post(this.apiRoot + '/insertDashboardCat', data, httpOptions);
    }

    deleteAllDashboardCat(data) {
        return this.http.post(this.apiRoot + '/deleteAllDashboardCat', data, httpOptions);
    }

    changeUserPassword(data) {
        return this.http.post(this.apiRoot + '/changeUserPassword', data, httpOptions);
    }

    updateSingleLoginID(payLoad) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.userUploadApiRoot + '/singleLoginIDUpdate', payLoad, httpOptions);
        } else {
            return this.http.post(this.apiRoot + '/singleLoginIDUpdate', payLoad, httpOptions);
        }
    }

    updateBulkLoginID(payLoad) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.userUploadApiRoot + '/bulkLoginIDUpdate', payLoad, httpOptions);
        } else {
            return this.http.post(this.apiRoot + '/bulkLoginIDUpdate', payLoad, httpOptions);
        }
    }

    searchCitDataForExport(data) {
        return this.http.post(this.apiRoot + '/searchCitDataForExport', data, httpOptions);
    }

    searchSscDataForExport(data) {
        return this.http.post(this.apiRoot + '/searchSscDataForExport', data, httpOptions);
    }

    AdvancesearchTicketForChr(data) {
        return this.http.post(this.apiRoot + '/AdvancesearchTicketForChr', data, httpOptions);
    }

    searchAllChrDataForExport(data) {
        return this.http.post(this.apiRoot + '/searchAllChrDataForExport', data, httpOptions);
    }

    getResolutionTime(clientId, priorityId, ticket_type) {
        return this.http.get(this.apiRoot + '/getResolutionTime?clientId=' + clientId + '&priorityId=' + priorityId +
            '&ticket_type=' + ticket_type);
    }

    getCategoryIc(clientId, ticketTypeId) {
        return this.http.get(this.apiRoot + '/getCategoryIc?clientId=' + clientId + '&ticketTypeId=' + ticketTypeId);
    }

    getCategoryLevel(clientId, ticketTypeId) {
        return this.http.get(this.apiRoot + '/getCategoryLevel?clientId=' + clientId + '&ticketTypeId=' + ticketTypeId);
    }

    searchAllCategory(name, clientId, level_id) {
        return this.http.get(this.apiRoot + '/searchAllCategory?name=' + name + '&clientId=' + clientId + '&level_id=' + level_id);
    }

    getTicketAttributesClientWise(clientId, nextOffset, pageSize, paginationType, name = null, level_id = null, icSelected = null) {
        return this.http.get(this.apiRoot + '/getTicketAttributesClientWise?clientId=' + clientId + '&nextOffset=' + nextOffset +
            '&page_size=' + pageSize + '&paginationType=' + paginationType + '&name=' + name + '&level_id=' + level_id + '&firstCatId=' + icSelected);
    }

    updateMailTemplateLt(data) {
        return this.http.post(this.apiRoot + '/updateMailTemplateLt', data, httpOptions);
    }

    generateCitAppsHybridOpmzdReport(data) {
        if (this.config.type === 'LOCAL') {
            return this.http.post(this.reportRoot + '/lntCitAppsHybridOptimizedReportToExcel', data, httpOptions);
        } else {
            return this.http.post(this.geenrateReportRoot + '/generateCitAppsHybridOptimizedReport', data, httpOptions);
        }
    }

    getEmailAttrMaster(nextOffset, pageSize, paginationType, clientId) {
        return this.http.get(this.apiRoot + '/getEmailAttrMaster?clientId=' + clientId + '&nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType);
    }

    deleteEmailAttribute(data) {
        return this.http.post(this.apiRoot + '/deleteEmailAttribute', data, httpOptions);
    }

    AddEmailAttr(data) {
        return this.http.post(this.apiRoot + '/AddEmailAttr', data, httpOptions);
    }

    getAttributesParentWiseWithPriorityBasedOnSpGrp(clientId, tType, parentId, groupId
        , pType) {
        return this.http.get(this.apiRoot + '/getAttributesParentWiseWithPriorityBasedOnSpGrp?clientId=' + clientId
            + '&tType=' + tType + '&parentId=' +
            parentId + '&groupId=' + groupId + '&pType=' + pType);
    }

    getAllUsersByLevel(clientId, level) {
        return this.http.get(this.apiRoot + '/getAllUsersByLevel?clientId=' + clientId + '&level=' + level);
    }

    addApproverEnduserMaster(data) {
        return this.http.post(this.apiRoot + '/addApproverEnduserMaster', data, httpOptions);
    }

    deleteApproverEnduserMaster(data) {
        return this.http.post(this.apiRoot + '/deleteApproverEnduserMaster', data, httpOptions);
    }

    getApproverEnduserMaster(nextOffset, pageSize, paginationType, clientId) {
        return this.http.get(this.apiRoot + '/getApproverEnduserMaster?nextOffset=' + nextOffset + '&page_size=' +
            pageSize + '&paginationType=' + paginationType + '&clientId=' + clientId);
    }

    getMappedChildTicketDetails(clientId, ticket_type, ticketId) {
        return this.http.get(this.apiRoot + '/getMappedChildTicketDetails?clientId=' + clientId +
            '&seq=' + ticket_type + '&id=' + ticketId);
    }
    checkAllChildInCloseStatus(ticketId, clientId) {
        return this.http.get(this.apiRoot + '/checkAllChildInCloseStatus?clientId=' + clientId + '&id=' + ticketId);
    }

    getTktWrkFlowDtl(ticketId) {
        return this.http.get(this.apiRoot + '/getTktWrkFlowDtl?id=' + ticketId);
    }

    insertTktAdditionalPermission(data) {
        return this.http.post(this.apiRoot + '/insertTktAdditionalPermission', data, httpOptions);
    }

    getTktAdditionalPermission(ticketId) {
        return this.http.get(this.apiRoot + '/getTktAdditionalPermission?ticket_id=' + ticketId);
    }

    getBHODDetaisl(ticketId, userId, tktType) {
        return this.http.get(this.apiRoot + '/getBHODDetaisl?tid=' + ticketId + '&enduser_id=' + userId + '&tktType=' + tktType);
    }

    insertPlannedActivityTicketWise(data) {
        return this.http.post(this.apiRoot + '/insertPlannedActivityTicketWise', data, httpOptions);
    }

    updateActualActivityDt(data) {
        return this.http.post(this.apiRoot + '/updateActualActivityDt', data, httpOptions);
    }

    updateTktAdditionalPermission(data) {
        return this.http.post(this.apiRoot + '/updateTktAdditionalPermission', data, httpOptions);
    }

    getCreateTicketData_groupWise(user_id, ttype, clientId, grpLevel) {
        return this.http.get(this.apiRoot + '/getCreateTicketData_groupWise?user_id=' + user_id + '' +
            '&ticket_type=' + ttype + '&clientId=' + clientId + '&grpLevel=' + grpLevel);
    }

    generateautoTicketReport(clientid, fromDt, todate, user_id) {
        if (this.config.type === 'LOCAL') {
            return this.http.get(this.reportRoot + '/autoTicketReportGeneration_datewise?user_id=' + user_id + '' +
                '&clientid=' + clientid + '&fromDt=' + fromDt + '&todate=' + todate);
        } else {
            return this.http.get(this.apiRoot + '/autoTicketReportGeneration_datewise?user_id=' + user_id + '' +
                '&clientid=' + clientid + '&fromDt=' + fromDt + '&todate=' + todate);
        }
    }

    getoptimizedreportTicketDetailsReportByids(ticketId) {
        return this.http.get(this.apiRoot + '/getoptimizedreportTicketDetailsReportByids?tid=' + ticketId);
    }

    getUserTicketCount(clientId, ticketTypeId, req_user_id, supportgrp_id) {
        return this.http.get(this.apiRoot + '/getUserTicketCount?clientId=' + clientId + '&ticketTypeId=' + ticketTypeId
            + '&req_user_id=' + req_user_id + '&supportgrp_id=' + supportgrp_id);
    }

    getNextStatus(clientId, ticket_type_id, ticket_pres_status_id) {
        return this.http.get(this.apiRoot + '/getNextStatus?client_id=' + clientId + '&ticket_type_id=' + ticket_type_id +
            '&ticket_pres_status_id=' + ticket_pres_status_id);
    }


    custome_parent_child_attr_byId(clientId, attr_parent_id, type) {
        return this.http.get(this.apiRoot + '/custome_parent_child_attr_byId?client_id=' + clientId + '&attr_parent_id=' + attr_parent_id +
            '&type=' + type);
    }

    createBulkAssignmentTicket(data){
        return this.http.post(this.apiRoot + '/createBulkAssignmentTicket', data, httpOptions);

    }

    bulksearchsscDataForExport(data) {
        return this.http.post(this.apiRoot + '/bulksearchsscDataForExport', data, httpOptions);
    }

    // anand july 4
    forwardbasis() {
        return this.http.get(this.apiRoot + '/forwardbasis');
    }



    bulkAssignmentTicketUpdate(clientId) {
        return this.http.get(this.apiRoot + '/bulkAssignmentTicketUpdate?clientId=' + clientId );

    }



}



